import {AccountTree, Add, BuildCircle, Delete, Pageview, SendOutlined, Sms} from '@mui/icons-material';
import {
  Alert,
  AlertTitle,
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import moment from 'moment-timezone';
import React, {useEffect, useRef, useState} from 'react';
import {FormProvider, useFieldArray, useForm, useWatch} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import authSelectors from 'src/modules/auth/authSelectors';
import {
  effectiveIncidentAnswerType,
  seedYesNoFromCheckbox,
} from 'src/modules/incident/incidentFormAnswerCoerce';
import Storage from 'src/security/storage';
import {canShowTaskPdfExportForUi} from 'src/security/tareaPdfAccess';
import {canUseTaskEditClosedForUi} from 'src/security/taskEditClosedAccess';
import {canUseTaskReassignForUi} from 'src/security/taskReassignAccess';
import {canUseTaskReopenForUi} from 'src/security/taskReopenAccess';
import {canRespondOverdueTaskForUi} from 'src/security/taskRespondOverdueAccess';
import FilesFormItem from 'src/view/shared/form/items/FilesFormItem';
import ImagesFormItem from 'src/view/shared/form/items/ImagesFormItem';
import TextAreaFormItem from 'src/view/shared/form/items/TextAreaFormItem';
import Message from 'src/view/shared/message';
import ConfirmModal from 'src/view/shared/modals/ConfirmModal';
import FormWrapper from 'src/view/shared/styles/FormWrapper';
import FilesViewItem from 'src/view/shared/view/FilesViewItem';
import ImagesViewItem from 'src/view/shared/view/ImagesViewItem';
import CheckListTareaForm from 'src/view/tarea/form/CheckListTareaForm';
import PasosTareaForm from 'src/view/tarea/form/PasosTareaForm';
import TareaResourcesForm from 'src/view/tarea/form/TareaResourcesForm';

import {SaveOutlined} from '@mui/icons-material';
import actions from 'src/modules/tarea/form/tareaFormActions';
import {canUsePartialVerification} from 'src/security/partialVerificationAccess';
import {customButtonStyle} from 'src/theme/schemes/CustomTheme';
import ActivoListItem from 'src/view/activo/list/ActivoListItem';
import DescRegistroAutocompleteFormItem from 'src/view/descRegistro/autocomplete/DescRegistroAutocompleteFormItem';
import DivisionAutocompleteFormItem from 'src/view/division/autocomplete/DivisionAutocompleteFormItem';
import FirmaListItem from 'src/view/firma/list/FirmaListItem';
import {
  applyDivisionIdPolicyToPayload,
  canShowDivisionIdFieldInForm,
  isTenantFixedAdminRole,
  mapRecordOrCurrentDivisionToFormDivisionId,
} from 'src/view/shared/division/divisionIdFormPolicy';
import DatePickerFormItem from 'src/view/shared/form/items/DatePickerFormItem';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import InputNumberFormItem from 'src/view/shared/form/items/InputNumberFormItem';
import TareaProcedimientoAnidadoForm from 'src/view/tarea/form/TareaProcedimientoAnidadoForm';
import TareaReportProgressPage from './TareaReportProgressPage';

import {Assignment, Description, Edit, Gesture, Send} from '@mui/icons-material';
import Close from '@mui/icons-material/Close';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import FirmaFormPage from 'src/view/firma/form/FirmaFormPage';

import DrawerButton from 'src/view/shared/view/DrawerButton';

import {styled, useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import firmaSelectors from 'src/modules/firma/firmaSelectors';
import FirmaService from 'src/modules/firma/firmaService';
import firmaFormActions from 'src/modules/firma/form/firmaFormActions';
import layoutActions from 'src/modules/layout/layoutActions';
import Errors from 'src/modules/shared/error/errors';
import tareaFormActions from 'src/modules/tarea/form/tareaFormActions';
import tareaListActions from 'src/modules/tarea/list/tareaListActions';
import tareaPdf from 'src/modules/tarea/tareaPdf';
// import {generarReportePDF} from 'src/modules/tarea/reportePDF';
import tareaSelectors from 'src/modules/tarea/tareaSelectors';
import TareaService from 'src/modules/tarea/tareaService';
import MessagesView from 'src/view/comunicacionInterna/messenger/';
import ContentWrapper from 'src/view/layout/styles/ContentWrapper';
import Spinner from 'src/view/shared/Spinner';
import PageTitle from 'src/view/shared/styles/PageTitle';
import ClasificacionTagView from 'src/view/shared/view/ClasificacionTagView';
import UserAutocompleteFormItem from 'src/view/user/autocomplete/UserAutocompleteFormItem';
import TareaChildTasksList from '../children/TareaChildTasksList';
import TareaReassignTasksModal from '../list/TareaReassignTasksModal';
import TareaFormPage from './TareaFormPage';
import TareaPrePdfModal from './TareaPrePdfModal';
import TareaSendFormPage from './TareaSendFormPage';

import {applyIncidentAltCommentPrefillToPregunta} from 'src/modules/incident/incidentAltCommentPrefill';
import {applyIncidentPrefillToPreguntaField, lookupIncidentValueWithAliases} from 'src/modules/incident/incidentProcedurePrefill';
import {
  allRegisteredIncidentSubTableRowKeyPointers,
  applyIncidentSubTableRowPrefillToPregunta,
  buildQuestionsFromSubTableConfig,
  getIncidentSubTableDefForRowKeyPointer,
  isIncidentSubTableProcedureSubsection,
  resolveIncidentSubTableSubseccionForPreguntaIndex,
} from 'src/modules/incident/incidentSubTable';
import {
  ensureAndPrefillIncidentSubTableProcedureList,
  renumberProcedureListaIndexes,
} from 'src/modules/incident/incidentSubTableProcedureList';
import planificacionListActions from 'src/modules/planificacion/list/planificacionListActions';
import {
  customSequenceOptions as buildCustomSequenceOptions,
  resolveCustomSequenceValue,
} from 'src/modules/settings/customSequenceModel';
import settingsSelectors from 'src/modules/settings/settingsSelectors';
import {isIncidentLinkedClasificacion} from 'src/modules/shared/clasificacionIncidentLinked';
import {buildIsTaskQuestionsFromConfig} from 'src/modules/tarea/isTaskConfig';
import {
  getMissingRequiredMedicionesParcialId23Labels,
  normalizeMedicionesParcialId23,
  omitMedicionesParcialIfUnused,
  shouldPersistMedicionesParcial,
  shouldUseMedicionesParcialId23,
} from 'src/modules/tarea/medicionesParcialId23';
import {
  getMissingRequiredMedicionesParcialId24Labels,
  isId24ModeloTareaTitle,
  normalizeMedicionesParcialId24,
  shouldUseMedicionesParcialId24,
} from 'src/modules/tarea/medicionesParcialId24';
import {applyOtPremiumToleranceBoundsForChildTask} from 'src/modules/tarea/otPremiumToleranceBounds';
import {
  applyArticuloToleranceBoundsFromLista,
  resolvePlastyvergArticuloTitulo,
} from 'src/modules/tarea/plastyvergArticuloToleranceBounds';
import {isPlastyvergTenant} from 'src/modules/tarea/dynamicSubsectionPdfGrouping';
import {createAncestorNaTracker, isContainerNotApplicable} from 'src/modules/tarea/tareaParcialHelpers';
import {detectRootFolioPrefix, getTaskVisualLabel} from 'src/modules/tarea/taskVisualLabel';
import SelectFormItem from 'src/view/shared/form/items/SelectFormItem';
import MedicionesParcialId23Section from 'src/view/tarea/form/MedicionesParcialId23Section';
import MedicionesParcialId24Section from 'src/view/tarea/form/MedicionesParcialId24Section';

const CardWrapper = styled(Card)(
  ({theme}) => `
  position: relative;
  overflow: visible;
  //border: 2px solid ${theme.palette.divider};
  box-shadow: 0px 2px 2px -1px rgba(0,0,0,0.07),
              0px 1px 1px 1px rgba(0,0,0,0.09),
              0px 1px 3px 1px rgba(0,0,0,0.12);
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: inherit;
    z-index: 1;
    transition: ${theme.transitions.create(['box-shadow'])};
  }
  &.Mui-selected::after {
    box-shadow: 0 0 0 3px ${theme['colors'].primary.main};
  }
  `,
);
/** Texto visible para prefill de trabajador (perfilEmpleado); nunca usar el id como label. */
function buildPerfilEmpleadoPrefillLabel(raw: Record<string, any> | null | undefined): string {
  if (raw == null || typeof raw !== 'object') return '';
  if (raw.label != null && String(raw.label).trim() !== '') return String(raw.label).trim();
  if (raw.fullName != null && String(raw.fullName).trim() !== '') return String(raw.fullName).trim();
  const nombre = raw.nombre != null ? String(raw.nombre).trim() : '';
  const apellidos = raw.apellidos != null ? String(raw.apellidos).trim() : '';
  const composed = [nombre, apellidos].filter(Boolean).join(' ').trim();
  if (composed) return composed;
  if (raw.email != null && String(raw.email).trim() !== '') return String(raw.email).trim();
  return '';
}

/** Texto visible para prefill de usuario (modelo `user`); nunca usar el id como label. */
function buildUserPrefillLabel(raw: Record<string, any> | null | undefined): string {
  if (raw == null || typeof raw !== 'object') return '';
  if (raw.label != null && String(raw.label).trim() !== '') return String(raw.label).trim();
  if (raw.fullName != null && String(raw.fullName).trim() !== '') return String(raw.fullName).trim();
  const first = raw.firstName != null ? String(raw.firstName).trim() : '';
  const last = raw.lastName != null ? String(raw.lastName).trim() : '';
  const composed = [first, last].filter(Boolean).join(' ').trim();
  if (composed) return composed;
  if (raw.email != null && String(raw.email).trim() !== '') return String(raw.email).trim();
  return '';
}

function isIncidentWorkerKeyPointer(kp: string): boolean {
  return kp === 'employee' || kp === 'incident_employee' || kp === 'responsibleAdvisor' || kp === 'incident_responsibleAdvisor';
}

/** Campos del incidente que referencian `user` y se prellenan como tipo `usuario` en el procedimiento. */
function isIncidentUserRefKeyPointer(kp: string): boolean {
  return kp === 'areaManager' || kp === 'incident_areaManager';
}

/**
 * Obtiene el valor del incidente para un keyPointer.
 * Los keyPointers pueden ser "incident_employee" (formulario) o "employee" (schema incident).
 */
const getIncidentValueForKeyPointer = (incidentResponse: any, keyPointer: string): any => {
  if (!incidentResponse || !keyPointer) return undefined;
  const normalizeWorkerValue = (raw: any) => {
    if (raw == null) return raw;
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'object') {
      const id = raw.id ?? raw._id ?? null;
      if (!id) return raw;
      return {
        id,
        label: buildPerfilEmpleadoPrefillLabel(raw),
      };
    }
    return {id: raw, label: ''};
  };
  const normalizeUserRefPrefill = (raw: any) => {
    if (raw == null) return raw;
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'object') {
      const id = raw.id ?? raw._id ?? null;
      if (!id) return raw;
      return {
        id,
        label: buildUserPrefillLabel(raw),
      };
    }
    return {id: raw, label: ''};
  };

  let value = incidentResponse[keyPointer];
  if (isIncidentWorkerKeyPointer(keyPointer)) {
    value = normalizeWorkerValue(value);
  } else if (isIncidentUserRefKeyPointer(keyPointer)) {
    value = normalizeUserRefPrefill(value);
  }
  if (value !== undefined && value !== null && value !== '') return value;
  if (String(keyPointer).startsWith('incident_')) {
    const shortKey = String(keyPointer).replace(/^incident_/, '');
    const shortValue = incidentResponse[shortKey];
    if (isIncidentWorkerKeyPointer(shortKey)) return normalizeWorkerValue(shortValue);
    if (isIncidentUserRefKeyPointer(shortKey)) return normalizeUserRefPrefill(shortValue);
    if (shortValue !== undefined && shortValue !== null && shortValue !== '') return shortValue;
  }
  return lookupIncidentValueWithAliases(incidentResponse, keyPointer);
};

const hasRespuestaValue = (pregunta: any): boolean => {
  if (!pregunta || pregunta.tipo !== 'pregunta') return false;
  if (Array.isArray(pregunta?.additionalPhotos) && pregunta.additionalPhotos.length > 0) return true;
  const tipo = pregunta.tipoRespuesta;
  const value = pregunta?.[tipo];
  if (tipo === 'multiCheckbox') {
    return Array.isArray(value) && value.some((x) => x && (x.value === true || x.checked === true));
  }
  if (Array.isArray(value)) return value.length > 0;
  return value !== undefined && value !== null && value !== '';
};

const mergeIncidentPrefillIntoExistingList = (list: any[], record: any): any[] => {
  if (!Array.isArray(list) || list.length === 0) return list || [];
  const incidentResponse = record?.incidentResponse || record?.incident;
  const isClasificacionIncidente =
    isIncidentLinkedClasificacion(record?.clasificacion) || isIncidentLinkedClasificacion(record?.modeloTarea?.clasificacion);
  if (!incidentResponse || !isClasificacionIncidente) return list;

  return list.map((item, i) => {
    if (item?.tipo !== 'pregunta' || item?.tipoRespuesta === 'inspectionCheck') return item;

    let working = item;
    if (incidentResponse && working.tieneComentario) {
      const clone = {...working};
      applyIncidentAltCommentPrefillToPregunta(clone, incidentResponse);
      working = clone;
    }

    if (hasRespuestaValue(working)) return working;
    if (!working?.keyPointer) return working;

    if (allRegisteredIncidentSubTableRowKeyPointers().has(String(working.keyPointer))) {
      const def = getIncidentSubTableDefForRowKeyPointer(String(working.keyPointer));
      if (!def) return working;
      const sub = resolveIncidentSubTableSubseccionForPreguntaIndex(list, i, def);
      if (!sub || sub?.tipo !== 'subseccion' || !isIncidentSubTableProcedureSubsection(sub)) {
        return working;
      }
      const rows = incidentResponse?.[def.incidentRowsPath];
      const row = Array.isArray(rows) ? rows[Number(sub.dynamicIndex) || 0] : null;
      if (!row) return working;
      const cloned = {...working};
      applyIncidentSubTableRowPrefillToPregunta(cloned, String(working.keyPointer), row, def);
      return cloned;
    }

    const prefillValue = getIncidentValueForKeyPointer(incidentResponse, working.keyPointer);
    if (prefillValue === undefined || prefillValue === null) return working;

    const cloned = {...working};
    applyIncidentPrefillToPreguntaField(cloned, prefillValue);
    return cloned;
  });
};

const buildBlankProcedureList = (record: any) => {
  const blankFormList: any[] = [];
  if (record?.tipoVisualizacion !== 'Procedimiento') {
    return blankFormList;
  }

  const procedimientoInterfaz = record.procedimientoInterfaz || record.modeloTarea?.procedimiento?.formato;
  const incidentResponse = record.incidentResponse || record.incident;
  const isClasificacionIncidente =
    isIncidentLinkedClasificacion(record.clasificacion) || isIncidentLinkedClasificacion(record.modeloTarea?.clasificacion);

  procedimientoInterfaz?.forEach((seccion) => {
    blankFormList.push({
      tipo: 'seccion',
      categoria: seccion.categoria || (seccion.isDynamic ? i18n('common.section') : ''),
      isDynamic: seccion.isDynamic,
      allowNotApplicable: Boolean(seccion.allowNotApplicable),
      listIndex: blankFormList.length,
      listLength: seccion.subseccions?.length || 0,
    });
    seccion.subseccions?.forEach((subseccion) => {
      const subsectionIndex = blankFormList.length;
      const taskQuestions = subseccion.isTask ? buildIsTaskQuestionsFromConfig(subseccion) : [];
      const subTableQuestions = !subseccion.isTask ? buildQuestionsFromSubTableConfig(subseccion) : [];
      const generatedQuestions = subseccion.isTask ? taskQuestions : subTableQuestions;
      blankFormList.push({
        tipo: 'subseccion',
        categoria: subseccion.categoria || (subseccion.isDynamic ? i18n('common.subsection') : ''),
        isDynamic: subseccion.isDynamic,
        allowNotApplicable: Boolean(subseccion.allowNotApplicable),
        isTask: subseccion.isTask,
        taskConfig: subseccion.taskConfig,
        subTableConfig: subseccion.subTableConfig,
        subTableKind: subseccion.subTableKind || '',
        listIndex: subsectionIndex,
        listLength: generatedQuestions.length > 0 ? generatedQuestions.length : subseccion.preguntas?.length || 0,
      });
      if (subseccion.isTask) {
        taskQuestions.forEach((pregunta) => {
          blankFormList.push({
            tipo: 'pregunta',
            ...pregunta,
            listIndex: blankFormList.length,
            subsectionIndex,
          });
        });
      } else if (subTableQuestions.length > 0) {
        subTableQuestions.forEach((pregunta) => {
          blankFormList.push({
            tipo: 'pregunta',
            ...pregunta,
            listIndex: blankFormList.length,
            subsectionIndex,
          });
        });
      } else {
        subseccion.preguntas?.forEach((rawPregunta) => {
          const pregunta = {...rawPregunta};
          if (pregunta.tipoRespuesta === 'inspectionCheck') {
            pregunta.inspectionCheck = 'Aprobado';
          } else {
            pregunta.inspectionCheck = undefined;
            const incidentKey = pregunta.keyPointer;
            if (incidentKey && incidentResponse && isClasificacionIncidente) {
              const prefillValue = getIncidentValueForKeyPointer(incidentResponse, incidentKey);
              if (prefillValue !== undefined && prefillValue !== null) {
                applyIncidentPrefillToPreguntaField(pregunta, prefillValue);
              }
              applyIncidentAltCommentPrefillToPregunta(pregunta, incidentResponse);
            }
          }

          blankFormList.push({
            tipo: 'pregunta',
            ...pregunta,
            listIndex: blankFormList.length,
            subsectionIndex,
          });
        });
      }
    });
  });

  return blankFormList;
};

const agruparEnUnPaso = (flatList: any[]) => {
  const resultado: any[] = [];
  let sectionIndex = -1;
  let gruposPorIndex: Record<number, any[]> = {};
  let currentSub: any = null;

  const flushGrupos = () => {
    Object.entries(gruposPorIndex).forEach(([key, subs]) => {
      resultado.push({
        tipo: 'grupo',
        sectionIndex,
        listIndex: Number(key),
        subsecciones: subs,
      });
    });
  };

  for (let i = 0; i <= flatList.length; i++) {
    const item = flatList[i] ?? {tipo: 'seccion'};
    if (item.tipo === 'seccion') {
      if (sectionIndex >= 0) {
        flushGrupos();
      }
      if (i === flatList.length) break;

      sectionIndex++;
      resultado.push({
        tipo: 'header',
        sectionIndex,
        categoria: item.categoria,
        isDynamic: item.isDynamic,
        allowNotApplicable: Boolean(item.allowNotApplicable),
        notApplicable: Boolean(item.notApplicable),
      });
      gruposPorIndex = {};
      currentSub = null;
      continue;
    }

    if (item.tipo === 'subseccion') {
      const key = item.listIndex ?? 0;
      const idx = gruposPorIndex[key]?.length ?? 0;
      const subClone = {
        ...item,
        preguntas: [],
        subsectionIndex: idx,
        dynamicIndex: idx,
        isLastSubsection: true,
      };

      if (gruposPorIndex[key] && gruposPorIndex[key].length > 0) {
        gruposPorIndex[key][gruposPorIndex[key].length - 1].isLastSubsection = false;
      } else {
        gruposPorIndex[key] = [];
      }
      gruposPorIndex[key].push(subClone);
      currentSub = subClone;
      continue;
    }

    if (item.tipo === 'pregunta' && currentSub) {
      currentSub.preguntas.push({...item});
    }
  }

  return resultado;
};

const desagruparEnUnPaso = (agrupado: any[]) => {
  const flatList: any[] = [];

  agrupado.forEach((entry) => {
    if (entry.tipo === 'header') {
      const {categoria, isDynamic, allowNotApplicable, notApplicable} = entry;
      flatList.push({
        tipo: 'seccion',
        categoria,
        isDynamic,
        allowNotApplicable: Boolean(allowNotApplicable),
        notApplicable: Boolean(notApplicable),
      });
    } else if (entry.tipo === 'grupo') {
      entry.subsecciones?.forEach((sub) => {
        const {preguntas, subsectionIndex, dynamicIndex, isLastSubsection, ...subSinExtras} = sub;
        void subsectionIndex;
        void dynamicIndex;
        void isLastSubsection;
        flatList.push(subSinExtras);
        preguntas?.forEach((preg) => {
          flatList.push(preg);
        });
      });
    }
  });

  return flatList;
};

function TareaForm(props) {
  const theme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));

  const [confirm, setConfirm] = useState(false);
  const [formValidationErrors, setFormValidationErrors] = useState<Record<string, string>>({});
  const [waitingForAutosave, setWaitingForAutosave] = useState(false);
  /** Solo se setea tras un guardado exitoso en esta apertura del drawer (no al montar). */
  const [lastProcedureSavedAt, setLastProcedureSavedAt] = useState<moment.Moment | null>(null);
  const cancelPendingAutosaveRef = useRef<(() => void) | null>(null);
  const autosaveInFlightRef = useRef<Promise<any> | null>(null);
  const waitingForAutosaveRef = useRef(false);
  const AUTOSAVE_DEBOUNCE_MS = 10000;
  //const [expanded, setExpanded] = useState(false);

  const dispatch = useDispatch();

  const currentUser = useSelector(authSelectors.selectCurrentUser);
  const currentTenant = useSelector(authSelectors.selectCurrentTenant);
  const roles: any = useSelector(authSelectors.selectRoles);
  const tenantAccessContext = useSelector(authSelectors.selectTenantAccessContext);
  const tenantAccessContextLoadStatus = useSelector(authSelectors.selectTenantAccessContextLoadStatus);
  const tenantFeatureKeys: string[] = tenantAccessContext?.featureKeys || [];
  const partialVerificationEnabled = canUsePartialVerification(currentTenant?.id);

  const record = props.record;
  const showMedicionesParcialId23 = shouldUseMedicionesParcialId23({
    tenantId: currentTenant?.id,
    modeloTareaTitulo: record?.modeloTarea?.titulo || record?.tituloTarea,
    primeroDelParcial: record?.primeroDelParcial,
  });
  const showMedicionesParcialId24 = shouldUseMedicionesParcialId24({
    tenantId: currentTenant?.id,
    modeloTareaTitulo: record?.modeloTarea?.titulo || record?.tituloTarea,
    primeroDelParcial: record?.primeroDelParcial,
  });
  const isBlockedForFueraPlazo =
    record?.estado === 'FueraPlazo' &&
    !canRespondOverdueTaskForUi(currentTenant?.id, tenantFeatureKeys, tenantAccessContextLoadStatus);

  const title = props.title;
  const isTaskEditing = props.isTaskEditing;
  const setIsTaskEditing = props.setIsTaskEditing;

  const progressEditor = !props.hideEditProgress && roles.includes('editorProgreso');

  const rolesThatEditProgress = ['editorProgreso', 'ejecutorProgreso'];
  const canEditProgress = !props.hideEditProgress && roles.some((role) => rolesThatEditProgress.includes(role));
  const recordHasProgress = props.record?.taskProgressList?.length > 0;

  const controlInicioActividad = roles.includes('controlInicioActividad');
  const [initialValues] = useState(() => {
    const record = props.record || {};

    const inicioReal = controlInicioActividad ? null : moment();
    const baseListaProcedimiento =
      record.listaProcedimiento?.length > 0 ? record.listaProcedimiento : buildBlankProcedureList(record) || [];
    const incidentResponse = record.incidentResponse || record.incident;
    const isClasificacionIncidente =
      isIncidentLinkedClasificacion(record?.clasificacion) || isIncidentLinkedClasificacion(record?.modeloTarea?.clasificacion);
    const listaConTestigos =
      isClasificacionIncidente && incidentResponse
        ? ensureAndPrefillIncidentSubTableProcedureList(baseListaProcedimiento, incidentResponse)
        : baseListaProcedimiento;
    const listaProcedimiento = (() => {
      const withOtPremium = applyOtPremiumToleranceBoundsForChildTask(
        mergeIncidentPrefillIntoExistingList(listaConTestigos, record),
        record.parentTask,
        isId24ModeloTareaTitle(record.modeloTarea?.titulo || record.tituloTarea),
      );
      if (!isPlastyvergTenant(currentTenant?.id)) {
        return withOtPremium;
      }
      return applyArticuloToleranceBoundsFromLista(withOtPremium, resolvePlastyvergArticuloTitulo(record));
    })();
    const estructuraAnidada = agruparEnUnPaso(listaProcedimiento);

    const tarea = {
      tipoVisualizacion: record.tipoVisualizacion,
      clasificacion: record.clasificacion,
      modeloTarea: record.modeloTarea,
      tituloTarea: record.tituloTarea,
      customSequenceId: record.customSequenceId || null,
      customSequencePrefix: record.customSequencePrefix || null,
      listaProcedimiento,
      estructuraAnidada,
      blankFormList: record.blankFormList?.length > 0 ? record.blankFormList : buildBlankProcedureList(record) || [],
      respuestaInterfaz: record.respuestaInterfaz,
      horometro: record.horometro || record.activo?.horometro,
      fechaHorometro: record.fechaHorometro || record.activo?.fechaHorometro,
      detenciones: record.detenciones,
      kilometraje: record.kilometraje || record.activo?.kilometraje,
      comentarioEnviado: record.comentarioEnviado,
      fotosEnviadas: record.fotosEnviadas,
      documentosEnviados: record.documentosEnviados,
      pasoActual: record.pasoActual,
      ultimaUbicacion: record.ultimaUbicacion,
      comentarioEvaluador: record.comentarioEvaluador,
      estado: record.estado,
      comienzo: record.comienzo ? moment(record.comienzo) : inicioReal,
      fin: record.fin ? moment(record.fin) : null,
      estadoActivacion: record.estadoActivacion,
      fechaActivacion: record.fechaActivacion ? moment(record.fechaActivacion) : null,
      enviada: record.enviada,
      esEvaluada: record.esEvaluada,
      evaluadores: record.evaluadores || [],
      createdBy: record.createdBy,
      gasto: record.gasto,
      encargados: record.encargados || [],
      inicio: record.inicio ? moment(record.inicio) : inicioReal,
      documentosAdjuntos: record.documentosAdjuntos || [],
      fotosAdjuntas: record.fotosAdjuntas || [],
      nota: record.nota,
      activosUtilizados: record.activosUtilizados || [],
      serviciosUtilizados: record.serviciosUtilizados || [],
      ubicacion: record.ubicacion,
      ubicacionGoogle: record.ubicacionGoogle,
      latitud: record.latitud,
      longitud: record.longitud,
      formularioPersonalizado: record.formularioPersonalizado || [],
      etiqueta: record.etiqueta,
      resourcesList: record.resourcesList || [],
      ejecutor: record.ejecutor,
      divisionId: mapRecordOrCurrentDivisionToFormDivisionId(record),
      primeroDelParcial: Boolean(record.primeroDelParcial),
      ...(shouldPersistMedicionesParcial({
        tenantId: currentTenant?.id,
        modeloTareaTitulo: record.modeloTarea?.titulo || record.tituloTarea,
        primeroDelParcial: record.primeroDelParcial,
      })
        ? {
            medicionesParcial: isId24ModeloTareaTitle(record.modeloTarea?.titulo || record.tituloTarea)
              ? normalizeMedicionesParcialId24(record.medicionesParcial)
              : normalizeMedicionesParcialId23(record.medicionesParcial),
          }
        : {}),
    };
    //console.log('%c⧭ TareaForm [tarea]', 'color: #016b48', tarea);
    return tarea;
  });

  useEffect(() => {
    if (!watchComienzo && !controlInicioActividad) {
      form.register('comienzo');
      form.setValue('comienzo', moment());
    }

    // if (watchEjecutor?.id !== currentUser.id) {
    //   if (roles.includes('administrador') || roles.includes('admin')) {
    //     return;
    //   }

    //   if (
    //     watchAceptadores?.filter((user) => user?.id === currentUser.id)?.length > 0 ||
    //     watchValidadores?.filter((user) => user?.id === currentUser.id)?.length > 0
    //   ) {
    //     return;
    //   }

    //   //getHistory().goBack();
    //   // ya no se redirige al usuario a la vista anterior
    // }

    // Mejor no hacer esto en lo absoluto por ahora, pero la idea es que:
    // Si la tarea está abierta y el usuario actual es el ejecutor, y la fecha límite es menor a la fecha actual, entonces se cambia el estado a "Fuera de plazo"
    // if (watchEjecutor?.id === currentUser.id && (watchEstado === 'Abierta')) {
    //   if (roles.includes('administrador') || roles.includes('admin')) return;
    //   if (moment(watchFechaLimite).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
    //     form.setValue('estado', 'FueraPlazo');
    //     return;
    //   }
    // }
  }, []);

  const form = useForm({
    mode: 'all',
    defaultValues: initialValues as any,
    shouldUnregister: false,
  });

  useEffect(() => {
    const parentTask = props.record?.parentTask;
    const toleranceBounds = parentTask?.isTaskSourceMeta?.toleranceBounds;
    if (!toleranceBounds || !props.record?.id) return;

    const currentLista = form.getValues('listaProcedimiento') || [];
    let updatedLista = applyOtPremiumToleranceBoundsForChildTask(
      currentLista,
      parentTask,
      isId24ModeloTareaTitle(props.record?.modeloTarea?.titulo || props.record?.tituloTarea),
    );
    if (isPlastyvergTenant(currentTenant?.id)) {
      updatedLista = applyArticuloToleranceBoundsFromLista(updatedLista, resolvePlastyvergArticuloTitulo(props.record));
    }
    form.setValue('listaProcedimiento', updatedLista);
    form.setValue('estructuraAnidada', agruparEnUnPaso(updatedLista));
  }, [props.record?.parentTask?.isTaskSourceMeta?.toleranceBounds, props.record?.id, form]);

  const showDivisionIdField = canShowDivisionIdFieldInForm(tenantAccessContext, isTenantFixedAdminRole(roles));

  /*
   * Bloque al inicio del formulario (debajo del encabezado de la tarea):
   * - Tipo de folio / secuencia: SelectFormItem `customSequencePrefix` (opciones customSequenceOptions).
   * - División: DivisionAutocompleteFormItem `divisionId` (etiqueta entities.division).
   * Condiciones originales: folio solo si `!record?.id && !props.createFromWebIncidente`; división si `showDivisionIdField`.
   */
  // TODO: Definir cuándo volver a mostrar folio/secuencia y división al inicio; mientras tanto quedan ocultos siempre.
  const showFolioSecuenciaAndDivisionAtFormStart = false;

  const formState = form.formState;
  const {isDirty, isValid, errors} = formState; // read all formState values to subscribe to changes

  // console.log('%c⧭ formState', 'color: #00b300', {
  //   isDirty,
  //   isValid,
  //   errors,
  // });

  const trigger = form.trigger;
  const control = form.control;
  const watchTipoVisualizacion = record?.tipoVisualizacion;
  const watchEstructuraAnidadaRaw = useWatch({name: 'estructuraAnidada', control});
  const watchEstructuraAnidada: any = watchEstructuraAnidadaRaw || [];

  const watchComienzo: any = useWatch({name: 'comienzo', control});
  const watchEstado: any = useWatch({name: 'estado', control});
  const watchHorometro: any = useWatch({name: 'horometro', control});
  const watchFechaHorometro: any = useWatch({name: 'fechaHorometro', control});
  const watchKilometraje: any = useWatch({name: 'kilometraje', control});
  const watchFotosAdjuntas: any = useWatch({name: 'fotosAdjuntas', control});
  const watchDocumentosAdjuntos: any = useWatch({name: 'documentosAdjuntos', control});
  const watchDocumentosEnviados: any = useWatch({name: 'documentosEnviados', control});
  const watchFotosEnviadas: any = useWatch({name: 'fotosEnviadas', control});

  const {
    fields: detenciones,
    append: appendDetencion,
    remove: removeDetencion,
  } = useFieldArray({
    control,
    name: 'detenciones',
  }) as any;

  const [prePdfModalVisible, setPrePdfModalVisible] = useState(false);

  const hasPermissionToCreate = useSelector(tareaSelectors.selectPermissionToCreate);
  const hasPermissionToSign = useSelector(firmaSelectors.selectPermissionToEdit);
  const hasPermissionToReadFirmas = useSelector(firmaSelectors.selectPermissionToRead);

  const [firmasListas, setFirmasListas] = useState(
    () =>
      record?.firmas?.filter(
        (firma) => (firma.firma || firma?.firmaRef?.publicUrl || firma?.firmaRef?.downloadUrl) && firma.firmada,
      ) || [],
  );

  const [expanded, setExpanded] = useState(true);

  const [loadingPdf, setLoadingPdf] = useState(false);

  const [exportPdfMenuAnchorEl, setExportPdfMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const exportPdfMenuOpen = Boolean(exportPdfMenuAnchorEl);

  const handleExportPdfMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setExportPdfMenuAnchorEl(event.currentTarget);
  };

  const handleExportPdfMenuClose = () => {
    setExportPdfMenuAnchorEl(null);
  };

  const doExportPdf = async (pageOrientation) => {
    handleExportPdfMenuClose();
    setLoadingPdf(true);
    try {
      await tareaPdf.exportDataAsPdf(record, {pageOrientation});
    } catch (error) {
      //throw error;
    }
    setLoadingPdf(false);
  };

  const [reassignModalVisible, setReassignModalVisible] = useState(false);

  const hasPermissionToReassign = useSelector(tareaSelectors.selectPermissionToReassign);
  const hasPermissionToEditClosed = useSelector(tareaSelectors.selectPermissionToEditClosed);
  const canReassignForUi = canUseTaskReassignForUi(
    hasPermissionToReassign,
    tenantFeatureKeys,
    tenantAccessContextLoadStatus,
    roles,
  );
  const canEditClosedForUi = canUseTaskEditClosedForUi(
    hasPermissionToEditClosed,
    tenantFeatureKeys,
    tenantAccessContextLoadStatus,
    roles,
  );
  const canReopenForUi = canUseTaskReopenForUi(
    hasPermissionToEditClosed,
    tenantFeatureKeys,
    tenantAccessContextLoadStatus,
    roles,
  );

  const settings = useSelector(settingsSelectors.selectSettings);

  const customSequenceOptions = buildCustomSequenceOptions(settings?.customSequences || []);

  const [loadingReOpen, setLoadingReOpen] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [modalNota, setModalNota] = useState<any>(null);
  const [modalNotaLoading, setModalNotaLoading] = useState<any>(false);

  const [pageOrientation, setPageOrientation] = useState('portrait');

  const watchClasificacion: any = record?.clasificacion;
  const watchActivo: any = record?.activo;
  const watchModeloTarea: any = record?.modeloTarea;
  const watchTareaSelected: any = useWatch({name: 'tarea', control});
  const watchHorometroAnterior: any = record?.horometroAnterior;
  const watchFechaHorometroAnterior: any = record?.fechaHorometroAnterior;
  const watchComentarioEnviado: any = form.getValues('comentarioEnviado');

  useEffect(() => {
    if (record?.id) return;

    const selectedTask = form.getValues('tarea');

    const modelSequenceId =
      selectedTask?.record?.customSequenceId ||
      selectedTask?.customSequenceId ||
      watchTareaSelected?.record?.customSequenceId ||
      watchTareaSelected?.customSequenceId;
    const modelPrefix =
      selectedTask?.record?.customSequencePrefix ||
      selectedTask?.customSequencePrefix ||
      watchTareaSelected?.record?.customSequencePrefix ||
      watchTareaSelected?.customSequencePrefix;

    form.setValue(
      'customSequenceId',
      resolveCustomSequenceValue(settings?.customSequences || [], modelSequenceId, modelPrefix),
    );
  }, [watchTareaSelected, record?.id, settings?.customSequences, form]);

  const baseTaskPreviewRow = [{...props.record, descripcion: watchModeloTarea?.titulo}];
  const taskPreview = props.record.parentTask
    ? [{...props.record.parentTask, isParentTask: true}, ...baseTaskPreviewRow]
    : baseTaskPreviewRow;

  const isNewTaskWithoutId = !record?.id;

  const puedeResponderAsExecutor =
    ['Abierta', 'Rechazada', 'FueraPlazo'].includes(watchEstado) &&
    (currentUser?.id === record?.ejecutor?.id || isNewTaskWithoutId);

  const puedeResponder = puedeResponderAsExecutor || isTaskEditing;

  const showStartButton = puedeResponder && watchComienzo === null && controlInicioActividad;

  const checkFirma = (firma) => {
    return firma && !firma.firmada && firma.responsable?.id === currentUser.id;
  };

  const firma = checkFirma(props.firma) ? props.firma : record?.firmas?.find((f) => checkFirma(f));

  const hasAccessToIA = roles.includes('accesoIA');

  const onSubmit = async (values) => {
    setConfirm(false);
    const data = buildSubmissionValues(values);
    if (isTaskEditing && isTenantFixedAdminRole(roles)) {
      data.silent = true;
      data.estado = record.estado;
      data.updating = true;
    }
    const persistsProcedureList =
      Array.isArray(values?.listaProcedimiento) ||
      (Array.isArray(values?.estructuraAnidada) && values.estructuraAnidada.length > 0);
    const result = await props.onSubmit(props.record?.id, {...data, firmasListas});
    if (result && persistsProcedureList) {
      setLastProcedureSavedAt(moment());
    }
    return result;
  };

  /** Espera un autosave en vuelo (si hay) y cancela el debounce pendiente. Bloquea botones sin mensajes. */
  const waitForAutosaveIfNeeded = async () => {
    cancelPendingAutosaveRef.current?.();
    const inflight = autosaveInFlightRef.current;
    if (!inflight) return;

    waitingForAutosaveRef.current = true;
    setWaitingForAutosave(true);
    try {
      await inflight;
    } finally {
      waitingForAutosaveRef.current = false;
      setWaitingForAutosave(false);
    }
  };

  const onFinishProcedure = async (values) => {
    await waitForAutosaveIfNeeded();
    let data = values;

    const result = customValidationOnSave();
    if (!result) return false;

    if (isBlockedForFueraPlazo) {
      Message.error(i18n('errors.outOfDeadline'));
      return false;
    }

    data.fin = moment().toISOString();
    data.enviada = true;
    data.estado = 'PendienteRevision';

    return onSubmit(data);
  };

  const onTaskStart = async () => {
    if (isBlockedForFueraPlazo) {
      Message.error(i18n('errors.cannotStartOutOfDeadline'));
      return;
    }
    const now = moment();
    if (isNewTaskWithoutId) {
      form.setValue('comienzo', now);
      return;
    }
    const data = {
      comienzo: now,
      updating: true,
    };
    const success = await onSubmit(data);
    if (!success) return;
    form.setValue('comienzo', now);
  };

  const normalizeTimeAnswers = (listaProcedimiento: any[] = []) => {
    if (!Array.isArray(listaProcedimiento)) return listaProcedimiento;

    return listaProcedimiento.map((item) => {
      if (item?.tipo !== 'pregunta' || item?.tipoRespuesta !== 'time') return item;

      const rawTime = item?.time;
      if (!rawTime) return item;

      const formatted = moment(rawTime).isValid() ? moment(rawTime).format('HH:mm') : rawTime;
      return {
        ...item,
        time: formatted,
      };
    });
  };

  const buildSubmissionValues = (values) => {
    const data = {...values};
    if (Array.isArray(data.estructuraAnidada) && data.estructuraAnidada.length > 0) {
      const flat = desagruparEnUnPaso(data.estructuraAnidada);
      renumberProcedureListaIndexes(flat);
      data.listaProcedimiento = flat;
    }
    data.listaProcedimiento = normalizeTimeAnswers(data.listaProcedimiento);
    applyDivisionIdPolicyToPayload(data, tenantAccessContext, {
      treatAsTransversalSubmit: isTenantFixedAdminRole(roles),
    });
    omitMedicionesParcialIfUnused(data, {
      tenantId: currentTenant?.id,
      modeloTareaTitulo: record?.modeloTarea?.titulo || record?.tituloTarea,
      primeroDelParcial: data.primeroDelParcial ?? record?.primeroDelParcial,
    });
    return data;
  };

  const onFinishTasks = async (values) => {
    await waitForAutosaveIfNeeded();
    setConfirm(false);

    const result = customValidationOnFinish();
    if (!result) return false;

    if (isBlockedForFueraPlazo) {
      Message.error(i18n('errors.outOfDeadline'));
      return false;
    }

    values.fin = moment().toISOString();
    values.enviada = true;
    values.estado = 'PendienteRevision';

    return onSubmit(values);
  };

  const onSave = async (values) => {
    if (isNewTaskWithoutId) return;

    await waitForAutosaveIfNeeded();
    setConfirm(false);

    if (!isTaskEditing) {
      values.estado = 'Abierta';
      values.enviada = false;
      values.updating = true;
    }

    const result = customValidationOnSave();
    if (!result) return false;

    return onSubmit(values);
  };

  /** Borrador automático: mismo payload que Guardar / editar cerrada, sin toast ni bloqueo de UI. */
  const onAutosave = () => {
    if (isNewTaskWithoutId) return;
    if (autosaveInFlightRef.current || waitingForAutosaveRef.current) return;

    const values: any = {
      ...form.getValues(),
      updating: true,
      silent: true,
      autosave: true,
    };
    if (!isTaskEditing) {
      values.estado = 'Abierta';
      values.enviada = false;
    }
    const promise = Promise.resolve(onSubmit(values)).finally(() => {
      if (autosaveInFlightRef.current === promise) {
        autosaveInFlightRef.current = null;
      }
    });
    autosaveInFlightRef.current = promise;
    return promise;
  };

  const getNumericBound = (value: any): number | undefined => {
    if (value === null || value === undefined || value === '') return undefined;
    const numeric = Number(value);
    return Number.isNaN(numeric) ? undefined : numeric;
  };

  const checkPreguntaRango = (item: any): string | null => {
    if (!item || item?.tipo !== 'pregunta') return null;
    if (item.allowNotApplicable && item.notApplicable) return null;
    if (item.tipoRespuesta === 'numberField') {
      const min = getNumericBound(item.numberFieldMin);
      const max = getNumericBound(item.numberFieldMax);
      const hasBounds = min !== undefined || max !== undefined;
      if (!hasBounds) return null;
      const valor = item.numberField;
      const isBlank = valor === null || valor === undefined || valor === '';
      if (isBlank && !item.isRequired) return null;
      if (isBlank) return null;
      const numVal = Number(valor);
      if (Number.isNaN(numVal)) return `[${item.pregunta?.label}] Debe ser un número válido`;
      if (min !== undefined && numVal < min) return `[${item.pregunta?.label}] Debe ser al menos ${min}`;
      if (max !== undefined && numVal > max) return `[${item.pregunta?.label}] No puede superar ${max}`;
    }
    if (item.tipoRespuesta === 'ammount') {
      const min = getNumericBound(item.ammountMin);
      const max = getNumericBound(item.ammountMax);
      const hasBounds = min !== undefined || max !== undefined;
      if (!hasBounds) return null;
      const valor = item.ammount;
      const isBlank = valor === null || valor === undefined || valor === '';
      if (isBlank && !item.isRequired) return null;
      if (isBlank) return null;
      const numVal = Number(valor);
      if (Number.isNaN(numVal)) return `[${item.pregunta?.label}] Debe ser un número válido`;
      if (min !== undefined && numVal < min) return `[${item.pregunta?.label}] Debe ser al menos ${min}`;
      if (max !== undefined && numVal > max) return `[${item.pregunta?.label}] No puede superar ${max}`;
    }
    return null;
  };

  const checkPreguntaRequired = (pregunta: any): string | null => {
    if (!pregunta || pregunta.tipo !== 'pregunta' || !pregunta.isRequired) return null;
    if (pregunta.allowNotApplicable && pregunta.notApplicable) return null;
    const tipoRespuesta = effectiveIncidentAnswerType(pregunta);
    const label = pregunta.pregunta?.label;
    const msg = `La pregunta [${label}] es obligatoria`;
    if (tipoRespuesta === 'files') return !pregunta?.files?.length && !pregunta?.images?.length ? msg : null;
    if (tipoRespuesta === 'textFromImage') return !pregunta?.image ? msg : null;
    if (tipoRespuesta === 'multiCheckbox') {
      const anySelected = pregunta[tipoRespuesta]?.some((item: any) => item.value);
      return !anySelected ? msg : null;
    }
    if (tipoRespuesta === 'yesNo') {
      return !(pregunta.yesNo || seedYesNoFromCheckbox(pregunta)) ? msg : null;
    }
    return !pregunta[tipoRespuesta] ? msg : null;
  };

  const validarMantenimiento = () => {
    if (watchClasificacion === 'mantenimiento') {
      if (watchActivo?.tipoMedicionMantenimiento === 'Horas') {
        // validate that detenciones FieldArray values are set // hora, descRegistro, horas
        let detenciones = form.getValues('detenciones');
        let sumHoras = 0;
        if (detenciones?.length > 0) {
          let detencionesValidas = true;
          detenciones.forEach((detencion) => {
            if (!detencion?.hora || !detencion?.descRegistro || !detencion?.horas) {
              detencionesValidas = false;
            }
            detencion.horas = Number(detencion.horas);
            sumHoras += detencion.horas;
          });
          if (!detencionesValidas) {
            Message.error('Debe completar los campos de las detenciones agregadas');
            return false;
          }
        }
        if (sumHoras < justificarHoras) {
          Message.error(
            `Debe justificar al menos ${justificarHoras} hora${justificarHoras > 1 ? 's' : ''} ${i18n('common.ofDetentions')}`,
          );
          return false;
        }
        if (sumHoras > justificarHoras) {
          Message.error(
            `No puede justificar más de ${justificarHoras} hora${justificarHoras > 1 ? 's' : ''} ${i18n('common.ofDetentions')}`,
          );
          return false;
        }
        if (watchHorometro < watchHorometroAnterior) {
          Message.error('El horometro es menor al ingresado anteriormente');
          return false;
        }
      }
      if (watchActivo?.tipoMedicionMantenimiento === 'Kilometraje') {
        if (watchKilometraje < watchActivo.kilometraje) {
          Message.error('El kilometraje es menor al ingresado anteriormente');
          return false;
        }
      }
    }
    return true;
  };

  const validateRequiredMedicionesParcial = () => {
    const values: any = form.getValues();
    const modeloTareaTitulo = record?.modeloTarea?.titulo || record?.tituloTarea;
    const primeroDelParcial = values?.primeroDelParcial ?? record?.primeroDelParcial;
    const missing: string[] = [];
    if (
      shouldUseMedicionesParcialId23({
        tenantId: currentTenant?.id,
        modeloTareaTitulo,
        primeroDelParcial,
      })
    ) {
      missing.push(...getMissingRequiredMedicionesParcialId23Labels(values?.medicionesParcial, i18n));
    }
    if (
      shouldUseMedicionesParcialId24({
        tenantId: currentTenant?.id,
        modeloTareaTitulo,
        primeroDelParcial,
      })
    ) {
      missing.push(...getMissingRequiredMedicionesParcialId24Labels(values?.medicionesParcial, i18n));
    }
    if (missing.length) {
      Message.error(i18n('entities.tarea.medicionesParcial.requiredFields', missing.join(', ')));
      return false;
    }
    return true;
  };

  const customValidationOnFinish = () => {
    if (!validarMantenimiento()) return false;
    if (!validateRequiredMedicionesParcial()) return false;
    return true;
  };

  const customValidationOnSave = () => {
    if (!validarMantenimiento()) return false;
    if (!validateRequiredMedicionesParcial()) return false;
    return true;
  };

  const buildPreguntaId = (label: string, listIndex: number, subsectionIndex: number) =>
    `${label}__${listIndex}__${subsectionIndex}`;

  type ScrollTarget =
    | {type: 'pregunta'; preguntaId: string; label: string}
    | {type: 'preguntaFallback'; label: string}
    | {type: 'dynamicTable'; groupIndex: number};

  const scrollToScrollTarget = (target: ScrollTarget): boolean => {
    if (typeof document === 'undefined') return false;
    if (target.type === 'pregunta' || target.type === 'preguntaFallback') {
      const el =
        target.type === 'pregunta'
          ? (Array.from(document.querySelectorAll('[data-pregunta-id]')).find(
              (e) => (e as HTMLElement).getAttribute('data-pregunta-id') === target.preguntaId,
            ) as HTMLElement | undefined)
          : (Array.from(document.querySelectorAll('[data-pregunta-label]')).find(
              (e) => (e as HTMLElement).getAttribute('data-pregunta-label') === target.label,
            ) as HTMLElement | undefined);
      if (el) {
        el.scrollIntoView?.({behavior: 'smooth', block: 'center'});
        return true;
      }
    } else if (target.type === 'dynamicTable') {
      const el = document.querySelector(`[data-dynamic-table-index="${target.groupIndex}"]`) as HTMLElement | undefined;
      if (el) {
        el.scrollIntoView?.({behavior: 'smooth', block: 'center'});
        return true;
      }
    }
    return false;
  };

  const scrollToFormError = (targetLabel?: string, targetFieldPath?: string) => {
    if (targetFieldPath && typeof form.setFocus === 'function') {
      try {
        form.setFocus(targetFieldPath, {shouldSelect: true});
      } catch {
        // fallback
      }
    }
    if (targetLabel) scrollToScrollTarget({type: 'preguntaFallback', label: targetLabel});
    if (!targetLabel && !targetFieldPath && typeof document !== 'undefined') {
      const firstErrorEl = document.querySelector('[data-pregunta-id], [data-pregunta-label]') as HTMLElement | undefined;
      if (firstErrorEl) firstErrorEl.scrollIntoView?.({behavior: 'smooth', block: 'center'});
    }
  };

  const SCROLL_DELAY_MS = 750;

  const scrollToErrorsBottomToTop = (orderedTargets: ScrollTarget[]) => {
    if (orderedTargets.length === 0) return;
    const fromBottomToTop = [...orderedTargets].reverse();
    fromBottomToTop.forEach((target, i) => {
      setTimeout(() => scrollToScrollTarget(target), i * SCROLL_DELAY_MS);
    });
  };

  const getFirstErrorFieldPath = (err: any): string | null => {
    if (!err || typeof err !== 'object') return null;
    if (err.ref?.name) return err.ref.name;
    for (const key of Object.keys(err)) {
      const path = getFirstErrorFieldPath(err[key]);
      if (path) return path;
    }
    return null;
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  const doConfirm = async () => {
    await waitForAutosaveIfNeeded();
    const isValid = await trigger();
    const validationErrors: Record<string, string> = {};
    const orderedScrollTargets: ScrollTarget[] = [];
    const seenDynamicGroups = new Set<number>();

    const estructuraAnidada = form.getValues('estructuraAnidada');
    if (!Array.isArray(estructuraAnidada) || estructuraAnidada.length === 0) {
      const listaProcedimiento = form.getValues('listaProcedimiento') || [];
      const fallbackTargets: ScrollTarget[] = [];
      const seenLabels = new Set<string>();
      const fallbackTracker = createAncestorNaTracker();
      listaProcedimiento.forEach((pregunta) => {
        fallbackTracker.observe(pregunta);
        if (pregunta?.tipo !== 'pregunta') return;
        if (fallbackTracker.covered) return;
        const label = pregunta.pregunta?.label || pregunta.pregunta?.titulo;
        let msg = checkPreguntaRango(pregunta);
        if (!msg) msg = checkPreguntaRequired(pregunta);
        if (msg && label && !seenLabels.has(label)) {
          seenLabels.add(label);
          validationErrors[label] = msg;
          fallbackTargets.push({type: 'preguntaFallback', label});
        }
      });
      if (fallbackTargets.length > 0) {
        setFormValidationErrors(validationErrors);
        const firstMsg = fallbackTargets[0].type === 'preguntaFallback' ? validationErrors[fallbackTargets[0].label] : null;
        Message.error(
          fallbackTargets.length === 1 && firstMsg
            ? firstMsg
            : `${fallbackTargets.length} errores de validación. Revise los campos señalados.`,
        );
        setTimeout(() => scrollToErrorsBottomToTop(fallbackTargets), 50);
        return false;
      }
    } else {
      let currentHeader: any = null;
      estructuraAnidada.forEach((entry, groupIndex) => {
        if (entry?.tipo === 'header') {
          currentHeader = entry;
          return;
        }
        if (entry?.tipo !== 'grupo') return;
        if (isContainerNotApplicable(currentHeader)) return;
        const subsecciones = entry.subsecciones || [];
        const primeraSubseccion = subsecciones[0];
        const isDynamic = Boolean(primeraSubseccion?.isDynamic);

        subsecciones.forEach((subseccion, subsectionIdx) => {
          if (isContainerNotApplicable(subseccion)) return;
          const subsectionIndex = subseccion.subsectionIndex ?? subseccion.dynamicIndex ?? subsectionIdx;
          const listIndex = entry.listIndex ?? 0;
          (subseccion.preguntas || []).forEach((pregunta) => {
            if (pregunta?.isTaskExecutorFromSource) return;

            const label = pregunta.pregunta?.label || pregunta.pregunta?.titulo;
            let msg: string | null = checkPreguntaRango(pregunta);
            if (!msg) msg = checkPreguntaRequired(pregunta);

            if (msg && label) {
              const preguntaId = buildPreguntaId(label, listIndex, subsectionIndex);
              validationErrors[preguntaId] = msg;
              const scrollTarget: ScrollTarget = isDynamic
                ? {type: 'dynamicTable', groupIndex}
                : {type: 'pregunta', preguntaId, label};
              if (isDynamic) {
                if (!seenDynamicGroups.has(groupIndex)) {
                  seenDynamicGroups.add(groupIndex);
                  orderedScrollTargets.push(scrollTarget);
                }
              } else {
                orderedScrollTargets.push(scrollTarget);
              }
            }
          });
        });
      });

      if (orderedScrollTargets.length > 0) {
        setFormValidationErrors(validationErrors);
        const errorCount = Object.keys(validationErrors).length;
        const singleMsg =
          orderedScrollTargets[0].type === 'pregunta' ? validationErrors[orderedScrollTargets[0].preguntaId] : null;
        Message.error(
          orderedScrollTargets.length === 1 && singleMsg
            ? singleMsg
            : `${errorCount} errores de validación. Revise los campos señalados.`,
        );
        setTimeout(() => scrollToErrorsBottomToTop(orderedScrollTargets), 50);
        return false;
      }
    }

    setFormValidationErrors({});
    setConfirm(true);
    if (!isValid) {
      const formErrors = errors.estructuraAnidada || errors.listaProcedimiento;
      const extractLabels = (obj: any): string[] => {
        if (!obj || typeof obj !== 'object') return [];
        if (obj.type === 'required' && obj.ref?.name) {
          return [obj.message || obj.ref.name];
        }
        return Object.values(obj).flatMap((v) => extractLabels(v));
      };
      const labels = extractLabels(formErrors);
      if (labels.length > 0) {
        Message.error(`Preguntas obligatorias sin respuesta: ${labels.length}`);
      }
      const firstPath = getFirstErrorFieldPath(formErrors);
      setTimeout(() => scrollToFormError(undefined, firstPath ?? undefined), 50);
    }
  };

  const doCloseConfirm = () => {
    setConfirm(false);
  };

  const {saveLoading, modal} = props;

  // Autoguardado en respuesta normal y en "editar tarea cerrada".
  const canAutosave =
    !isNewTaskWithoutId && !showStartButton && (isTaskEditing || (puedeResponderAsExecutor && !props.hideGuardarBorrador));

  const canAutosaveRef = useRef(canAutosave);
  canAutosaveRef.current = canAutosave;
  const saveLoadingRef = useRef(saveLoading);
  saveLoadingRef.current = saveLoading;
  const confirmRef = useRef(confirm);
  confirmRef.current = confirm;
  const onAutosaveRef = useRef(onAutosave);
  onAutosaveRef.current = onAutosave;

  useEffect(() => {
    if (!canAutosave) {
      cancelPendingAutosaveRef.current?.();
      cancelPendingAutosaveRef.current = null;
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const clearTimer = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };

    cancelPendingAutosaveRef.current = clearTimer;

    const subscription = form.watch((_values, info) => {
      if (!canAutosaveRef.current) {
        clearTimer();
        return;
      }
      // Incluye setValue sin shouldDirty (select/fecha/fotos en filas dinámicas, etc.).
      // Solo se ignoran eventos explícitos que no son change (p.ej. blur).
      if (info?.type && info.type !== 'change') return;

      clearTimer();
      timeoutId = setTimeout(() => {
        if (!canAutosaveRef.current) return;
        if (saveLoadingRef.current) return;
        if (confirmRef.current) return;
        if (waitingForAutosaveRef.current) return;
        if (autosaveInFlightRef.current) return;
        onAutosaveRef.current();
      }, AUTOSAVE_DEBOUNCE_MS);
    });

    return () => {
      clearTimer();
      cancelPendingAutosaveRef.current = null;
      subscription.unsubscribe();
    };
  }, [canAutosave, form]);

  const updateDetencion = (index, value, fechaHorometro) => {
    if (fechaHorometro) {
      value = moment(value);
      const fechaHorometroWithHora = moment(fechaHorometro).set({
        hour: value?.get('hour'),
        minute: value?.get('minute'),
        second: value?.get('second'),
      });
      form.setValue(`detenciones[${index}].hora`, fechaHorometroWithHora);
    }
  };

  const updateDetenciones = (fechaHorometro) => {
    let detenciones = form.getValues('detenciones');
    detenciones.forEach((detencion, index) => {
      updateDetencion(index, detencion.hora, fechaHorometro);
    });
  };

  const defaultFechaHorometro =
    (moment().isBefore(watchActivo?.fechaHorometro) ? watchActivo?.fechaHorometro : moment()) || moment();

  const cantidadHorasDisponibilidadDia = watchActivo?.cantidadHorasDisponibilidadDia || 11;
  const horasTrabajadas = watchHorometro - watchHorometroAnterior;
  const justificarHoras = cantidadHorasDisponibilidadDia - horasTrabajadas;
  const sumDetenciones = form
    .getValues('detenciones')
    ?.map((d) => d.horas || 0)
    .reduce((a, b) => {
      a = Number(a);
      b = Number(b);
      return a + b;
    }, 0);
  const horasPorJustificar = sumDetenciones >= justificarHoras ? 0 : justificarHoras - sumDetenciones;

  const [folioModalOpen, setFolioModalOpen] = useState(false);
  const [selectedFolioPrefix, setSelectedFolioPrefix] = useState<string | null>(null);
  const [applyFolioToChildren, setApplyFolioToChildren] = useState(true);
  const [removeNumeroCustom, setRemoveNumeroCustom] = useState(false);
  const [savingFolio, setSavingFolio] = useState(false);

  const doOpenFolioModal = () => {
    const detectedPrefix = detectRootFolioPrefix(record?.numeroCustom);

    setSelectedFolioPrefix(
      resolveCustomSequenceValue(settings?.customSequences || [], record?.customSequenceId, detectedPrefix),
    );
    setApplyFolioToChildren(true);
    setRemoveNumeroCustom(false);
    setFolioModalOpen(true);
  };

  const doCloseFolioModal = () => {
    setFolioModalOpen(false);
  };

  const doSaveFolio = async () => {
    try {
      setSavingFolio(true);

      const values = {
        customSequenceId: removeNumeroCustom ? null : selectedFolioPrefix,
        removeNumeroCustom,
        applyFolioToChildren,
        updating: true,
      };

      const ok = await props.onSubmit(record.id, values);

      if (ok !== false) {
        setFolioModalOpen(false);

        dispatch(
          layoutActions.doVisibleDrawer({
            drawerVisible: false,
            drawerId: null,
            recordId: null,
            drawerChanged: new Date().getTime(),
          }),
        );

        dispatch(planificacionListActions.doFetchCurrentFilter());
      }
    } catch (error) {
      Errors.handle(error);
    } finally {
      setSavingFolio(false);
    }
  };

  const folioOptionsForModal = customSequenceOptions;

  const doOpenReassignModal = () => {
    setReassignModalVisible(true);
  };

  const doCloseReassignModal = () => {
    setReassignModalVisible(false);
  };

  const renderReassignButton = () => {
    if (!canReassign) {
      return null;
    }

    const notAbierta = record.estado !== 'Abierta';

    if (notAbierta) {
      return null;
      // (
      //   <Tooltip followCursor title={'Debe seleccionar tareas en estado "Abierta"'}>
      //     <span>{notAbierta}</span>
      //   </Tooltip>
      // );
    }

    //const disabled = notAbierta// || loading;

    const button = (
      <Grid item>
        <Tooltip enterDelay={700} leaveDelay={150} enterNextDelay={400} followCursor title={i18n('common.reassignTask')}>
          <Button
            style={{height: 36}}
            type="button"
            disabled={false}
            onClick={doOpenReassignModal}
            startIcon={<Assignment />}
            size="small">
            {i18n('common.reassign')}
          </Button>
        </Tooltip>
      </Grid>
    );

    return button;
  };

  const doReOpenTask = async () => {
    try {
      dispatch({
        type: tareaFormActions.UPDATE_STARTED,
      });
      setLoadingReOpen(true);

      const id = record.id;
      const values = {estado: 'Abierta'};
      await TareaService.update(id, values);

      setLoadingReOpen(false);
      dispatch({
        type: tareaFormActions.UPDATE_SUCCESS,
      });
      dispatch({
        type: tareaListActions.PATCH_RECORD,
        payload: {id, values},
      });
      dispatch({
        type: layoutActions.DRAWER_VISIBLE,
        payload: {
          drawerId: 'TareaFormPage',
          drawerVisible: true,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: 'TareaFormPage',
          recordId: id,
        },
      });
    } catch (error) {
      Errors.handle(error);
    }
  };
  const doEditTask = async () => {
    setIsTaskEditing(true);
  };
  const stopEditTask = async () => {
    setIsTaskEditing(false);
  };

  const tareasBaseFilter = {
    esPlanificada: undefined,
    withChildren: undefined,
    fechaProgramacionRange: undefined, //fechaRange,
    usuariosSeleccionados: undefined, //usuariosSeleccionados?.map((row) => row.id || row),
    activosSeleccionados: undefined, //activosSeleccionados?.map((row) => row.id || row),
    planificacionesSeleccionadas: undefined, //planificacionesSeleccionadas?.map((row) => row.id || row),
  };

  const canViewSignature = !isTaskEditing && hasPermissionToReadFirmas && firmasListas?.length > 0;
  const canSign = !isTaskEditing && hasPermissionToSign && firma;
  //console.log('%c⧭ canSign', 'color: #e5de73', canSign, firma);
  const canReassign = !isTaskEditing && canReassignForUi;
  const canEditClosedTask = record?.id && ['Cerrada'].includes(record.estado) && canEditClosedForUi;
  /** Superadmin del tenant: misma edición “cerrada” + poder entrar en edición en otros estados si no es ejecutor (guardado silent en onSave). */
  const canAdminSilentMaintenanceEdit =
    isTenantFixedAdminRole(roles) && record?.id && !isNewTaskWithoutId && !puedeResponderAsExecutor;
  const canEnterTaskMaintenanceEdit = canEditClosedTask || canAdminSilentMaintenanceEdit;
  const canReopenTask = record?.id && !isTaskEditing && ['Cerrada', 'FueraPlazo'].includes(record.estado) && canReopenForUi;
  const canEditSignature = record?.id && isTaskEditing && ['admin'].some((role) => roles.includes(role));
  const canSendNewTask = !isTaskEditing && hasPermissionToCreate;
  const canExportPdf =
    record?.id &&
    !isTaskEditing &&
    ['Cerrada', 'EnRevision', 'PendienteRevision'].includes(record.estado) &&
    canShowTaskPdfExportForUi(roles, tenantFeatureKeys, tenantAccessContextLoadStatus);
  const canViewChildTasks = Boolean(record?.id);
  const hasPanelAcciones =
    canViewSignature ||
    canSign ||
    canReassign ||
    canEnterTaskMaintenanceEdit ||
    canReopenTask ||
    canSendNewTask ||
    canViewChildTasks ||
    canExportPdf;

  const renderSignatureMessages = () => {
    if (!canViewSignature || !firmasListas?.length) return;
    const generarMensaje = (firma) => {
      const signatureId = firma.id;
      if (firma.responsable?.id !== currentUser.id) return;

      const guardarNota = async () => {
        // guardar la nota
        try {
          setModalNotaLoading(true);
          // Obtener el contenido de la nota
          const notaContent = document?.getElementById('nota-content-' + signatureId) as any;
          await FirmaService.update(signatureId, {nota: notaContent?.value});
          dispatch(
            layoutActions.doVisibleDrawer({
              drawerId: 'DrawerFirmaFormPage',
              drawerVisible: false,
              drawerChanged: moment().unix(),
              drawerUpdateComponent: 'TareaFormPage',
              recordId: record?.id,
            }),
          );
        } catch (error) {
          // Manejar el error en caso de que ocurra
          console.error('Error al guardar la nota:', error);
        }
        setModalNotaLoading(false);
        setModalNota(null);
      };

      // abrir un modal para escribir una nota
      return (
        <>
          <Button style={{height: 36}} type="button" onClick={() => setModalNota(signatureId)} startIcon={<Edit />} size="small">
            {i18n('common.addNote')}
          </Button>

          <Dialog
            key={signatureId}
            open={modalNota === signatureId}
            onClose={() => setModalNota(null)}
            maxWidth="xs"
            fullWidth={true}>
            <DialogTitle>
              <span
                style={{
                  fontSize: '1.3rem',
                }}>
                {i18n('common.addNote')}
              </span>
            </DialogTitle>

            <DialogContent>
              <textarea
                id={'nota-content-' + signatureId}
                style={{
                  width: '100%',
                  height: '100px',
                  padding: '5px',
                  fontSize: '1rem',
                }}
                placeholder={i18n('common.writeNote')}
              />
            </DialogContent>

            <DialogActions>
              <Button
                disabled={modalNotaLoading}
                onClick={() => setModalNota(null)}
                color="primary"
                style={{
                  fontSize: '0.9rem',
                }}>
                {i18n('common.cancel')}
              </Button>
              <Button
                disabled={modalNotaLoading}
                onClick={() => guardarNota()}
                endIcon={modalNotaLoading && <CircularProgress size={20} />}
                color="primary"
                style={{
                  fontSize: '0.9rem',
                }}>
                {i18n('common.accept')}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    };

    return (
      <div className="tabla-mensajes-container">
        <table className="tabla-mensajes">
          <thead>
            <tr>
              <th>{i18n('common.date')}</th>
              <th>{i18n('common.user')}</th>
              <th>{i18n('common.message')}</th>
            </tr>
          </thead>
          <tbody>
            {firmasListas.map((firma) => (
              <tr key={firma.id}>
                <td>{moment(firma.updatedAt).format('DD-MM-YYYY HH:mm')}</td>
                <td>{firma.responsable?.fullName || i18n('common.unregisteredName')}</td>
                <td>{firma.nota || generarMensaje(firma)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const onSuccessPrePdfModal = async () => {
    if (isNewTaskWithoutId) {
      doClosePrePdfModal();
      return;
    }
    props.onSubmit(record.id, {...record, updating: true, silent: true});
    await doExportPdf(pageOrientation);
    doClosePrePdfModal();
  };

  const onCloseReadyPrePdfModal = () => {
    doClosePrePdfModal();
    doExportPdf(pageOrientation);
  };

  const onAbortPrePdfModal = () => {
    doClosePrePdfModal();
  };

  const doClosePrePdfModal = () => {
    setPrePdfModalVisible(false);
  };

  const doOpenPrePdfModal = (orientation) => {
    setPageOrientation(orientation);
    setPrePdfModalVisible(true);
  };

  const onChangePrePdfModal = (updatedTask) => {
    props.setRecord(updatedTask);
  };

  // const puedeResponder =
  //   (['Abierta', 'Rechazada', 'FueraPlazo'].includes(record?.estado) && currentUser.id === record?.ejecutor?.id) || isTaskEditing;

  const checkMultiWayDotVisibility = (row) => {
    // cuando la comunicacion interna esté en estado Abierta y tenga mensajes
    return (
      row.comunicacionInterna && row.comunicacionInterna.estado === 'Abierta' && row.comunicacionInterna.mensajeInternoCount > 0
    );
  };

  return (
    <>
      {record?.planificacion?.nombre && (
        <Box ml="5px">
          <PageTitle caption>{record?.planificacion?.nombre}</PageTitle>
        </Box>
      )}
      {!record?.planificacion?.nombre && (
        <Box ml="5px">
          {puedeResponder && <PageTitle caption>{title}</PageTitle>}
          {!puedeResponder && <PageTitle caption>{i18n('entities.tarea.view.title')}</PageTitle>}
        </Box>
      )}
      <Box style={{padding: '0px 20px 5px 5px'}}>
        <Box display="flex" flexDirection="row">
          <PageTitle>
            <Box display="flex" gap={2}>
              <Box>{getTaskVisualLabel(record)}</Box>
              <Box>{record?.tituloTarea || record?.titulo}</Box>
            </Box>
          </PageTitle>
          {!isDownSm && (
            <Box ml="auto" pr={3}>
              <ClasificacionTagView value={record?.estado} entity="tarea" fieldName="estado" />
            </Box>
          )}
        </Box>
        <Box display="flex" flexDirection="row">
          {record?.subtitulo && !isDownSm && (
            <Tooltip followCursor arrow title={record?.subtitulo}>
              <span>
                <Typography variant="subtitle1">{record?.subtitulo}</Typography>
              </span>
            </Tooltip>
          )}
          <Box ml="auto" pr={3}>
            <Grid container direction="row" gap={1} alignItems="center" wrap="nowrap">
              {isDownSm && (
                <Grid item>
                  <Box
                    sx={{
                      transform: 'scale(0.9)',
                    }}>
                    <Tooltip
                      followCursor
                      arrow
                      title={
                        i18n('entities.tarea.fields.estado') + ': ' + i18n(`entities.tarea.enumerators.estado.${record?.estado}`)
                      }>
                      <Box ml="auto">
                        <ClasificacionTagView value={record?.estado} entity="tarea" fieldName="estado" />
                      </Box>
                    </Tooltip>
                  </Box>
                </Grid>
              )}
              <Grid item>
                <Box
                  sx={{
                    transform: 'scale(0.9)',
                  }}>
                  <Tooltip
                    followCursor
                    arrow
                    title={
                      i18n('entities.tarea.fields.prioridad') +
                      ': ' +
                      i18n(`entities.tarea.enumerators.prioridad.${record?.prioridad}`)
                    }>
                    <Box>
                      <ClasificacionTagView value={record?.prioridad} entity="tarea" fieldName="prioridad" />
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item>
                <Box display="flex" gap={0.5} alignItems="center" justifyContent="end">
                  {record?.activo?.id && <BuildCircle />}
                  <strong>
                    {record?.activo?.id &&
                      (record?.activo.codigo && record?.activo.nombre && record?.activo.nombre !== record?.activo.codigo
                        ? `${record?.activo.nombre} - ${record?.activo.codigo}`
                        : record?.activo.codigo
                          ? record?.activo.codigo
                          : record?.activo.nombre)}
                  </strong>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {record?.subtitulo && isDownSm && (
          <Tooltip followCursor arrow title={record?.subtitulo}>
            <span>
              <Typography variant="subtitle1">{record?.subtitulo}</Typography>
            </span>
          </Tooltip>
        )}
      </Box>
      {record?.id && hasPanelAcciones && (
        <Grid container direction="column" sx={{pl: 0.2, pr: 2, flexWrap: 'nowrap'}}>
          <Grid item>
            {expanded && (
              <CardWrapper sx={{p: 0.3, mb: 0.5}} raised={false}>
                <Box
                  style={{
                    position: 'relative',
                    zIndex: 2,
                  }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* <QRCode
                        value={`${config.frontendUrl.protocol}://${config.frontendUrl.host}/tarea/${props.record?.id}`}
                        size={140}
                      /> */}
                    {/* Firmar tarea */}
                    {canSign && (
                      <Grid item>
                        <DrawerButton
                          style={{height: 36}}
                          drawerId={'DrawerFirmaFormPage'}
                          type={'button'}
                          tooltipTitle={i18n('common.signTask')}
                          buttonTitle={i18n('common.sign')}
                          buttonIcon={<Gesture />}
                          variant={'text'}
                          color={'default'}
                          width={window.innerWidth * 0.55}
                          onClose={() => dispatch(firmaFormActions.doResetSaveLoading())}
                          component={<FirmaFormPage record={firma} disabled={false} drawer={true} />}
                        />
                      </Grid>
                    )}
                    {/* Reasignar tarea */}
                    {canReassign && (
                      <>
                        {renderReassignButton()}
                        {reassignModalVisible && (
                          <TareaReassignTasksModal onClose={doCloseReassignModal} ids={[record.id]} drawerId={'TareaFormPage'} />
                        )}
                      </>
                    )}
                    {/* Editar tarea cerrada */}
                    {!isTaskEditing && canEnterTaskMaintenanceEdit && (
                      <Grid item>
                        <Tooltip
                          enterDelay={700}
                          leaveDelay={150}
                          enterNextDelay={400}
                          followCursor
                          title={i18n('common.editTask')}>
                          <Button
                            style={{height: 36}}
                            type="button"
                            disabled={false}
                            onClick={($event) => {
                              $event.stopPropagation();
                              doEditTask();
                            }}
                            startIcon={<Edit />}
                            size="small">
                            {i18n('common.editTask')}
                          </Button>
                        </Tooltip>
                      </Grid>
                    )}
                    {isTaskEditing && canEnterTaskMaintenanceEdit && (
                      <Grid item>
                        <Tooltip
                          enterDelay={700}
                          leaveDelay={150}
                          enterNextDelay={400}
                          followCursor
                          title={i18n('common.abortEditionWithoutSaving')}>
                          <Button
                            style={{height: 36}}
                            type="button"
                            disabled={false}
                            onClick={($event) => {
                              $event.stopPropagation();
                              stopEditTask();
                            }}
                            startIcon={<Close />}
                            size="small">
                            {i18n('common.abortTaskEdition')}
                          </Button>
                        </Tooltip>
                      </Grid>
                    )}
                    {/* Reabrir tarea */}
                    {canReopenTask && (
                      <Grid item>
                        {loadingReOpen && <CircularProgress size={20} />}
                        {!loadingReOpen && (
                          <Tooltip
                            enterDelay={700}
                            leaveDelay={150}
                            enterNextDelay={400}
                            followCursor
                            title={i18n('common.reopenTask')}>
                            <Button
                              style={{height: 36}}
                              type="button"
                              disabled={false}
                              onClick={($event) => {
                                $event.stopPropagation();
                                doReOpenTask();
                              }}
                              startIcon={<PlayCircleOutlineIcon />}
                              size="small">
                              {i18n('common.reopenTask')}
                            </Button>
                          </Tooltip>
                        )}
                      </Grid>
                    )}
                    {/* Enviar tarea asociada */}
                    {canSendNewTask && (
                      <Grid item>
                        <DrawerButton
                          style={{height: 36}}
                          drawerId={'DrawerTareaSendFormPage'}
                          width={window.innerWidth * 0.55}
                          type={'button'}
                          tooltipTitle={i18n('common.sendAssociatedTask')}
                          buttonTitle={i18n('common.associatedTask')}
                          buttonIcon={<Send />}
                          variant={'text'}
                          color={'default'}
                          component={
                            <TareaSendFormPage
                              silent={props.sendFormSilent}
                              drawerId={'DrawerTareaSendFormPage'}
                              drawer={true}
                              title={i18n('common.sendAssociatedTaskTo') + record.titulo}
                              parentTask={record}
                            />
                          }
                        />
                      </Grid>
                    )}
                    {/* Ver subtareas */}
                    {canViewChildTasks && (
                      <Grid item>
                        <DrawerButton
                          style={{height: 36}}
                          drawerId={'DrawerTareaChildTasksList'}
                          width={window.innerWidth * 0.9}
                          type={'button'}
                          tooltipTitle={i18n('entities.tarea.viewChildTasks')}
                          buttonTitle={i18n('entities.tarea.viewChildTasks')}
                          buttonIcon={<AccountTree />}
                          variant={'text'}
                          color={'default'}
                          component={
                            <TareaChildTasksList parentTask={record} drawer={true} sendFormSilent={props.sendFormSilent} />
                          }
                        />
                      </Grid>
                    )}
                    {/* Modificar folio */}
                    {/* {record?.id && (
                      <Grid item>
                        <Tooltip enterDelay={700} leaveDelay={150} enterNextDelay={400} followCursor title={'Modificar folio'}>
                          <Button
                            style={{height: 36}}
                            type="button"
                            disabled={false}
                            onClick={($event) => {
                              $event.stopPropagation();
                              doOpenFolioModal();
                            }}
                            startIcon={<Edit />}
                            size="small">
                            Modificar folio
                          </Button>
                        </Tooltip>
                      </Grid>
                    )} */}
                    {/* Ver tarea padre */}
                    {record.parentTask && (
                      <Grid item>
                        <DrawerButton
                          style={{height: 36}}
                          drawerId={'DrawerTareaFormPage'}
                          width={window.innerWidth * 0.55}
                          type={'button'}
                          tooltipTitle={'Ver ' + record.parentTask.titulo + ' ' + record.parentTask.tituloTarea}
                          buttonTitle={'Ver Tarea Padre'}
                          buttonIcon={<Pageview />}
                          variant={'text'}
                          color={'default'}
                          component={
                            <TareaFormPage
                              drawerId={'DrawerTareaFormPage'}
                              drawer={true}
                              disabled={true}
                              tarea={record.parentTask}
                            />
                          }
                        />
                      </Grid>
                    )}
                    {/* Seguimiento */}
                    {/* <Grid item>
                          <DrawerButton
                            style={{height: 36}}
                            drawerId={'DrawerTareaListPage'}
                            width={window.innerWidth * 0.55}
                            type={'button'}
                            tooltipTitle={'Seguimiento de Actividades'}
                            buttonTitle={'Seguimiento'}
                            buttonIcon={<AccountTree />}
                            variant={'text'}
                            color={'default'}
                            component={<TareaListPage filter={tareasBaseFilter} />}
                          />
                        </Grid> */}
                    {/* Exportar pdf */}
                    {canExportPdf && (
                      <Grid item>
                        {loadingPdf && <CircularProgress size={20} />}
                        {!loadingPdf && (
                          <>
                            <Tooltip
                              enterDelay={700}
                              leaveDelay={150}
                              enterNextDelay={400}
                              followCursor
                              title={i18n('common.exportPdf')}>
                              <Button
                                id="export-pdf-menu-button"
                                aria-controls={exportPdfMenuOpen ? 'export-pdf-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={exportPdfMenuOpen ? 'true' : undefined}
                                onClick={($event) => {
                                  $event.stopPropagation();
                                  handleExportPdfMenuOpen($event);
                                }}
                                startIcon={<Description />}
                                size="small">
                                {i18n('common.exportPdf')}
                              </Button>
                            </Tooltip>
                            <Menu
                              id="export-pdf-menu"
                              aria-labelledby="export-pdf-menu-button"
                              anchorEl={exportPdfMenuAnchorEl}
                              open={exportPdfMenuOpen}
                              onClose={handleExportPdfMenuClose}
                              anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                              }}>
                              <MenuItem
                                onClick={($event) => {
                                  $event.stopPropagation();
                                  if (hasAccessToIA) {
                                    doOpenPrePdfModal('portrait');
                                  } else {
                                    doExportPdf('portrait');
                                  }
                                }}>
                                Vertical
                              </MenuItem>
                              <MenuItem
                                onClick={($event) => {
                                  $event.stopPropagation();
                                  if (hasAccessToIA) {
                                    doOpenPrePdfModal('landscape');
                                  } else {
                                    doExportPdf('landscape');
                                  }
                                }}>
                                Horizontal
                              </MenuItem>
                            </Menu>
                          </>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </CardWrapper>
            )}
          </Grid>
        </Grid>
      )}
      <ContentWrapper
        style={{
          overflowY: 'auto',
          marginBottom: '10px',
        }}>
        <Box width={'calc(100%)'} pl={1} pr={2} pt={1}>
          <Grid
            container
            direction="row"
            columnGap={1}
            alignItems="center"
            wrap={!isDownSm ? 'nowrap' : undefined}
            sx={{mt: -1, pl: 1}}>
            <Grid item xs={7} sm={4} md={3}>
              <Box display="flex" flexDirection="row" columnGap={3} flexWrap={isDownSm ? 'wrap' : undefined}>
                {record?.inicioEstimado && (
                  <>
                    <Box display="flex" flexDirection="row" gap={1} justifyContent="flex-end">
                      <Typography variant="subtitle1" color="text.primary">
                        {i18n('common.start')}
                      </Typography>
                      <Typography variant="subtitle1" color="text.primary">
                        <b>{moment(record?.inicioEstimado).format('DD/MM/YYYY HH:mm')}</b>
                      </Typography>
                    </Box>
                    <Box display="flex" flexDirection="row" gap={1} justifyContent="flex-end">
                      <Typography variant="subtitle1" color="text.primary">
                        {i18n('common.end')}
                      </Typography>
                      <Typography variant="subtitle1" color="text.primary">
                        <b>{moment(record?.finEstimado).format('DD/MM/YYYY HH:mm')}</b>
                      </Typography>
                    </Box>
                  </>
                )}
                {!record?.inicioEstimado && (
                  <>
                    <Box display="flex" flexDirection="row" gap={1} justifyContent="flex-end">
                      <Typography variant="subtitle1" color="text.primary">
                        {i18n('common.scheduled')}
                      </Typography>
                      <Typography variant="subtitle1" color="text.primary">
                        <b>{moment(record?.fechaProgramacion).format('DD/MM/YYYY')}</b>
                      </Typography>
                    </Box>
                  </>
                )}
                {record?.fechaLimite && (
                  <>
                    <Box display="flex" flexDirection="row" gap={1} justifyContent="flex-end">
                      <Typography variant="subtitle1" color="text.primary">
                        {i18n('common.deadline')}
                      </Typography>
                      <Typography variant="subtitle1" color="text.primary">
                        <b>{record?.fechaLimite ? moment(record?.fechaLimite).format('DD/MM/YYYY') : ''}</b>
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
            <Grid item xs={5} sm={8} md={9} justifyContent={!isDownSm ? 'flex-end' : undefined}>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent={!isDownSm ? 'flex-end' : undefined}
                gap={0.5}>
                <Tooltip followCursor arrow placement="top" title={record?.ejecutor?.fullName || record?.ejecutor?.email}>
                  <Avatar
                    sx={{
                      width: 20,
                      height: 20,
                    }}
                    src={record?.ejecutor?.avatars?.length > 0 ? record?.ejecutor?.avatars[0]?.downloadUrl : ''}
                  />
                </Tooltip>
                {record?.ejecutor?.fullName || record?.ejecutor?.email}
                <Box onClick={($event) => $event.stopPropagation()}>
                  <Badge color="primary" variant="dot" overlap="circular" invisible={!checkMultiWayDotVisibility(record)}>
                    <DrawerButton
                      drawerId={'DrawerMultiway'}
                      type={'icon'}
                      width={window.innerWidth * 0.55}
                      tooltipTitle={'Chat'}
                      buttonTitle={'Chat'}
                      buttonIcon={<Sms />}
                      stopPropagation={true}
                      component={<MessagesView drawer={true} record={record?.comunicacionInterna} tipo={'Tarea'} row={record} />}
                    />
                  </Badge>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {renderSignatureMessages()}
        {props.initLoading && <Spinner />}
        <Box style={{width: '100%'}} pl={1} pr={2} pt={1}>
          <FormWrapper
            style={{
              flexShrink: 0,
            }}>
            <FormProvider {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                {puedeResponder && (
                  <React.Fragment>
                    <Grid container direction="column">
                      {/* Tipo de folio/secuencia y división: ver bloque comentario y TODO junto a showFolioSecuenciaAndDivisionAtFormStart más arriba. */}
                      {showFolioSecuenciaAndDivisionAtFormStart && !record?.id && !props.createFromWebIncidente && (
                        <Grid item xs={12} style={{padding: '16px 16px 0 16px'}}>
                          <SelectFormItem
                            name="customSequenceId"
                            label="Folio"
                            options={customSequenceOptions}
                            required={false}
                          />
                        </Grid>
                      )}
                      {showFolioSecuenciaAndDivisionAtFormStart && showDivisionIdField && (
                        <Grid item xs={12} style={{padding: '8px 16px 0 16px'}}>
                          <DivisionAutocompleteFormItem
                            name="divisionId"
                            label={i18n('entities.division.label')}
                            required={false}
                          />
                        </Grid>
                      )}
                      {!props.hidePendienteView && (
                        <Grid item>
                          {/* <Box pl={1} pr={2}>
                            <PendienteView
                              drawer={props.drawer}
                              record={taskPreview}
                              dontOpenRecord={true}
                              hideComunicacionInterna={props.hideComunicacionInterna}
                              hideProgressbar={props.hideProgressbar}
                              hideExportButton={true}
                            />
                          </Box> */}

                          {watchModeloTarea?.descripcion && (
                            <Box p={1}>
                              <Box pl={0}>
                                <Typography variant={'h5'} color="textSecondary">
                                  {i18n('common.description')}
                                </Typography>
                              </Box>
                              <Box pl={0}>
                                <Typography variant={'body2'} color="textSecondary">
                                  {watchModeloTarea?.descripcion}
                                </Typography>
                              </Box>
                            </Box>
                          )}
                        </Grid>
                      )}

                      <React.Fragment>
                        {canEditProgress && !showStartButton && !isNewTaskWithoutId && (
                          <Box sx={{my: 1, px: 1, width: '100%'}}>
                            <TareaReportProgressPage
                              record={props.record}
                              updating
                              expandable
                              noBreadcrumb
                              onSaveSuccess={(id, values) => {
                                dispatch(actions.setRecord({...props.record, ...values}));
                              }}
                            />
                          </Box>
                        )}

                        {showStartButton && (
                          <Box p={3} style={{width: '100%'}}>
                            <Button
                              style={{
                                width: '100%',
                                ...customButtonStyle,
                                ...(isBlockedForFueraPlazo ? {opacity: 0.6} : {}),
                              }}
                              variant="contained"
                              color="primary"
                              disabled={saveLoading}
                              type="button"
                              onClick={() => onTaskStart()}
                              startIcon={<SendOutlined />}
                              size="large">
                              {i18n('common.startTask')}
                            </Button>
                          </Box>
                        )}

                        {watchEstado === 'Rechazada' && (
                          <Grid sx={{p: 1}} item lg={12}>
                            <Alert severity="error">
                              <AlertTitle style={{marginBottom: 10}}>
                                {i18n('common.taskHasBeenRejected')}
                                {record.firmas?.length > 0 ? i18n('common.dueToFollowingReasons') : ''}
                              </AlertTitle>

                              {record.firmas
                                ?.filter((firma) => firma.nota)
                                ?.map((firma, index) => (
                                  <Grid key={index} style={{marginTop: 5}} container>
                                    {firma.nota}
                                  </Grid>
                                ))}
                            </Alert>
                          </Grid>
                        )}

                        <Grid container sx={{p: 1}}>
                          <Grid item lg={props.drawer ? 12 : 3} md={8} sm={12} xs={12}>
                            <ImagesViewItem label={i18n('entities.tarea.fields.fotosAdjuntas')} value={watchFotosAdjuntas} />
                          </Grid>
                          <Grid item lg={props.drawer ? 12 : 3} md={8} sm={12} xs={12}>
                            <FilesViewItem
                              label={i18n('entities.tarea.fields.documentosAdjuntos')}
                              value={watchDocumentosAdjuntos}
                            />
                          </Grid>
                        </Grid>

                        <Grid spacing={3} container sx={{p: 1}}>
                          {/* <Grid item lg={12}>
                        <h2>Respuesta</h2>
                      </Grid> */}

                          {watchClasificacion === 'mantenimiento' && (
                            <Grid item lg={12}>
                              <h2>
                                {i18n('common.answerTheFollowingQuestionsAssociatedTo')} <ActivoListItem value={watchActivo} />
                              </h2>
                            </Grid>
                          )}

                          {watchClasificacion === 'mantenimiento' && (
                            <React.Fragment>
                              {watchActivo?.tipoMedicionMantenimiento === 'Horas' && (
                                <Grid item lg={12} xs={12}>
                                  <Grid item sm={6} xs={12}>
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.dailyHoursAvailability')}: {cantidadHorasDisponibilidadDia}
                                    </label>
                                    <br />
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.workedHours')}: {horasTrabajadas}
                                    </label>
                                    <br />
                                    <br />
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('pastHourmeter')}:{' '}
                                      {new Intl.NumberFormat('es-CL', {
                                        currency: 'CLP',
                                        style: 'decimal',
                                      }).format(watchHorometroAnterior || 0)}
                                    </label>
                                    <br />
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.hourmeter')}:{' '}
                                      {new Intl.NumberFormat('es-CL', {
                                        currency: 'CLP',
                                        style: 'decimal',
                                      }).format(watchHorometro || 0)}
                                    </label>

                                    <InputNumberFormItem
                                      size={'large'}
                                      name="horometro"
                                      label={i18n('entities.formulario.fields.horometro')}
                                      placeholder={i18n('common.enterHourmeter')}
                                      required={false}
                                      disableFormat
                                      defaultValue={watchActivo?.horometro || 0}
                                      min={watchActivo?.horometro}
                                    />
                                  </Grid>
                                  {/* fecha horometro */}
                                  <Grid item sm={6} xs={12}>
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.pastHourmeterDate')}:{' '}
                                      {moment(watchFechaHorometroAnterior).format('DD/MM/YYYY')}
                                    </label>
                                    <br />
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.hourmeterDate')}:{' '}
                                      <DatePickerFormItem
                                        name="fechaHorometro"
                                        label={i18n('entities.formulario.fields.fechaHorometro')}
                                        required={false}
                                        defaultValue={defaultFechaHorometro}
                                        onChange={(fechaHorometro) => {
                                          updateDetenciones(fechaHorometro);
                                        }}
                                        minDate={watchActivo?.fechaHorometro}
                                      />
                                    </label>
                                  </Grid>
                                </Grid>
                              )}

                              {watchActivo?.tipoMedicionMantenimiento === 'Kilometros' && (
                                <Grid item lg={12} xs={12}>
                                  <Grid item lg={props.drawer ? 12 : 5} md={8} sm={12} xs={12}>
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.addedMileage')}:{' '}
                                      {new Intl.NumberFormat('es-CL', {
                                        currency: 'CLP',
                                        style: 'decimal',
                                      }).format(watchKilometraje || 0)}
                                    </label>

                                    <InputNumberFormItem
                                      size={'large'}
                                      name="kilometraje"
                                      label={i18n('entities.formulario.fields.kilometraje')}
                                      placeholder={i18n('common.enterMileage')}
                                      required={false}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </React.Fragment>
                          )}

                          {
                            /* {window.innerWidth <= 768 && (
                          <Grid
                            item
                            lg={props.drawer ? 12 : 6}
                          >
                            <h2
                              style={{
                                marginBottom: 20,
                              }}
                            >
                              {' '}
                              Detalles Adicionales <hr></hr>
                            </h2>
                            <TextAreaFormItem
                              name="comentarioEnviado"
                              label={i18n(
                                'entities.tarea.fields.comentarioEnviado',
                              )}
                              required={false}
                            />

                            <FilesFormItem
                              name="documentosEnviados"
                              label={i18n(
                                'entities.tarea.fields.documentosEnviados',
                              )}
                              required={false}
                              storage={
                                Storage.values
                                  .tareaDocumentosEnviados
                              }
                              max={undefined}
                              formats={undefined}
                            />

                            <ImagesFormItem
                              name="fotosEnviadas"
                              label={i18n(
                                'entities.tarea.fields.fotosEnviadas',
                              )}
                              required={false}
                              storage={
                                Storage.values
                                  .tareaFotosEnviadas
                              }
                              max={3}
                            />
                          </Grid>
                        )} */
                            ''
                          }

                          {showMedicionesParcialId23 && (
                            <Grid item xs={12}>
                              <MedicionesParcialId23Section disabled={showStartButton || props.disabled} />
                            </Grid>
                          )}

                          {showMedicionesParcialId24 && (
                            <Grid item xs={12}>
                              <MedicionesParcialId24Section disabled={showStartButton || props.disabled} />
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Procedimiento' && (
                            <Grid item lg={props.drawer ? 12 : 6} xs={12}>
                              {watchEstructuraAnidada.length > 0 && (
                                <TareaProcedimientoAnidadoForm
                                  record={record}
                                  editar={!showStartButton}
                                  esRespuesta={true}
                                  name="estructuraAnidada"
                                  customButton={props.principalFormButton}
                                  formValidationErrors={formValidationErrors}
                                />
                              )}
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Pasos' && (
                            <Grid item lg={props.drawer ? 12 : 6}>
                              <PasosTareaForm record={record} readOnly={showStartButton} name="respuestaInterfaz" />
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Checklist' && (
                            <Grid item lg={props.drawer ? 12 : 6}>
                              <CheckListTareaForm record={record} readOnly={showStartButton} name="respuestaInterfaz" />
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Estandar' && !showStartButton && (
                            <Grid item lg={props.drawer ? 12 : 6}>
                              <h2
                                style={{
                                  marginBottom: 20,
                                }}>
                                {' '}
                                Detalles Generales <hr></hr>
                              </h2>
                              <TextAreaFormItem
                                name="comentarioEnviado"
                                label={i18n('entities.tarea.fields.comentarioEnviado')}
                                required={false}
                              />

                              <FilesFormItem
                                name="documentosEnviados"
                                label={i18n('entities.tarea.fields.documentosEnviados')}
                                required={false}
                                storage={Storage.values.tareaDocumentosEnviados}
                                max={undefined}
                                formats={undefined}
                              />

                              <ImagesFormItem
                                name="fotosEnviadas"
                                label={i18n('entities.tarea.fields.fotosEnviadas')}
                                required={false}
                                storage={Storage.values.tareaFotosEnviadas}
                                //max={3}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </React.Fragment>
                    </Grid>

                    {confirm && (
                      <ConfirmModal
                        title={i18n('common.areYouSure')}
                        onConfirm={
                          watchTipoVisualizacion !== 'Procedimiento'
                            ? form.handleSubmit(onFinishTasks)
                            : form.handleSubmit(onFinishProcedure)
                        }
                        onClose={() => doCloseConfirm()}
                        okText={i18n('common.yes')}
                        cancelText={i18n('common.no')}
                      />
                    )}
                  </React.Fragment>
                )}

                {!isTaskEditing &&
                  ['Abierta', 'Rechazada', 'FueraPlazo'].includes(watchEstado) &&
                  currentUser.id !== record?.ejecutor?.id && (
                    <React.Fragment>
                      <Grid container direction="column">
                        {!props.hidePendienteView && (
                          <Grid item>
                            {/* <Box pl={1} pr={2}>
                              <PendienteView
                                drawer={props.drawer}
                                record={taskPreview}
                                dontOpenRecord={true}
                                hideComunicacionInterna={props.hideComunicacionInterna}
                                hideProgressbar={props.hideProgressbar}
                                hideExportButton={true}
                              />
                            </Box> */}

                            {watchModeloTarea?.descripcion && (
                              <Box p={1}>
                                <Box pl={0}>
                                  <Typography variant={'h5'} color="textSecondary">
                                    {i18n('common.description')}
                                  </Typography>
                                </Box>
                                <Box pl={0}>
                                  <Typography variant={'body2'} color="textSecondary">
                                    {watchModeloTarea?.descripcion}
                                  </Typography>
                                </Box>
                              </Box>
                            )}
                          </Grid>
                        )}

                        {/* <ListItemButton
                    onClick={() => setExpanded(!expanded)}
                    style={{ padding: 20 }}
                  >
                    <ListItemIcon>
                      <h2>{form.watch('titulo')}</h2>
                    </ListItemIcon>
                    <ListItemText />
                    {expanded ? (
                      <ExpandMore />
                    ) : (
                      <ExpandLess />
                    )}
                  </ListItemButton> */}

                        {/* <Grid
                    item
                    lg={props.drawer ? 12 : 7}
                    md={8}
                    sm={12}
                    xs={12}
                  >
                    <div style={{ marginBottom: 15 }}>
                      <QRCode
                        value={`${config.frontendUrl.protocol}://${config.frontendUrl.host}/tarea/${props.record?.id}`}
                        size={140}
                      />
                    </div>
                  </Grid> */}

                        <React.Fragment>
                          {(progressEditor || recordHasProgress) && !isNewTaskWithoutId && (
                            <Box sx={{my: 1, px: 1, width: '100%'}}>
                              <TareaReportProgressPage
                                record={props.record}
                                updating
                                expandable
                                noBreadcrumb
                                readOnly={!progressEditor}
                                onSaveSuccess={(id, values) => {
                                  dispatch(actions.setRecord({...props.record, ...values}));
                                }}
                              />
                            </Box>
                          )}
                          {watchEstado === 'Rechazada' && (
                            <Grid sx={{p: 1}} item lg={12}>
                              <Alert severity="error">
                                <AlertTitle style={{marginBottom: 10}}>
                                  {i18n('common.taskHasBeenRejected')}
                                  {record.firmas?.length > 0 ? i18n('common.dueToFollowingReasons') : ''}
                                </AlertTitle>

                                {record.firmas
                                  ?.filter((firma) => firma.nota)
                                  ?.map((firma, index) => (
                                    <Grid key={index} style={{marginTop: 5}} container>
                                      {firma.nota}
                                    </Grid>
                                  ))}
                              </Alert>
                            </Grid>
                          )}

                          <Grid container sx={{p: 1}}>
                            <Grid item lg={props.drawer ? 12 : 3} md={8} sm={12} xs={12}>
                              <ImagesViewItem label={i18n('entities.tarea.fields.fotosAdjuntas')} value={watchFotosAdjuntas} />
                            </Grid>
                            <Grid item lg={props.drawer ? 12 : 3} md={8} sm={12} xs={12}>
                              <FilesViewItem
                                label={i18n('entities.tarea.fields.documentosAdjuntos')}
                                value={watchDocumentosAdjuntos}
                              />
                            </Grid>
                          </Grid>

                          <Grid spacing={3} container sx={{p: 1}}>
                            {/* <Grid item lg={12}>
                        <h2>Respuesta</h2>
                      </Grid> */}
                            {watchClasificacion === 'mantenimiento' && (
                              <Grid item lg={12}>
                                <ActivoListItem value={watchActivo} />
                              </Grid>
                            )}

                            {watchClasificacion === 'mantenimiento' && (
                              <React.Fragment>
                                {watchActivo?.tipoMedicionMantenimiento === 'Horas' && (
                                  <Grid item lg={12} xs={12}>
                                    <Grid item sm={6} xs={12}>
                                      <label
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: 20,
                                        }}>
                                        {i18n('common.addedHourmeter')}:{' '}
                                        {new Intl.NumberFormat('es-CL', {
                                          currency: 'CLP',
                                          style: 'decimal',
                                        }).format(watchHorometro || 0)}
                                      </label>
                                    </Grid>
                                    {/* fecha horometro */}
                                    <Grid item sm={6} xs={12}>
                                      <label
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: 20,
                                        }}>
                                        {i18n('common.hourmeterDate')}:{' '}
                                        {watchFechaHorometro ? moment(watchFechaHorometro).format('DD-MM-YYYY') : ''}
                                      </label>
                                    </Grid>
                                  </Grid>
                                )}

                                {watchActivo?.tipoMedicionMantenimiento === 'Kilometros' && (
                                  <Grid item lg={12} xs={12}>
                                    <Grid item lg={props.drawer ? 12 : 5} md={8} sm={12} xs={12}>
                                      <label
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: 20,
                                        }}>
                                        {i18n('common.addedMileage')}:{' '}
                                        {new Intl.NumberFormat('es-CL', {
                                          currency: 'CLP',
                                          style: 'decimal',
                                        }).format(watchKilometraje || 0)}
                                      </label>
                                    </Grid>
                                  </Grid>
                                )}
                              </React.Fragment>
                            )}

                            {showMedicionesParcialId23 && (
                              <Grid item xs={12}>
                                <MedicionesParcialId23Section disabled={true} />
                              </Grid>
                            )}

                            {showMedicionesParcialId24 && (
                              <Grid item xs={12}>
                                <MedicionesParcialId24Section disabled={true} />
                              </Grid>
                            )}

                            {watchTipoVisualizacion === 'Procedimiento' && (
                              <Grid item lg={props.drawer ? 12 : 6} xs={12}>
                                {watchEstructuraAnidada.length > 0 && (
                                  <TareaProcedimientoAnidadoForm
                                    record={record}
                                    editar={false}
                                    esRespuesta={true}
                                    name="estructuraAnidada"
                                    customButton={props.principalFormButton}
                                    formValidationErrors={formValidationErrors}
                                  />
                                )}
                              </Grid>
                            )}

                            {watchTipoVisualizacion === 'Pasos' && (
                              <Grid item lg={props.drawer ? 12 : 6}>
                                <PasosTareaForm record={record} readOnly={true} name="respuestaInterfaz" />
                              </Grid>
                            )}

                            {watchTipoVisualizacion === 'Checklist' && (
                              <Grid item lg={props.drawer ? 12 : 6}>
                                <CheckListTareaForm record={record} readOnly={true} name="respuestaInterfaz" />
                              </Grid>
                            )}

                            {watchTipoVisualizacion === 'Estandar' && (
                              <Grid item lg={props.drawer ? 12 : 6} mt={2}>
                                <Grid container direction="column" gap={2}>
                                  <Box>
                                    <Typography variant="h4" pb={1}>
                                      Comentario Enviado
                                    </Typography>
                                    <Typography variant="subtitle1" component="pre" whiteSpace="pre-line">
                                      {watchComentarioEnviado}
                                    </Typography>
                                    {!watchComentarioEnviado && (
                                      <Alert severity="info">
                                        <AlertTitle>Sin Información</AlertTitle>
                                        No se encontraron datos
                                      </Alert>
                                    )}
                                  </Box>
                                  <Box>
                                    <Typography variant="h4" pb={1}>
                                      Documentos Enviados
                                    </Typography>
                                    {watchDocumentosEnviados?.length === 0 && (
                                      <Alert severity="info">
                                        <AlertTitle>Sin Información</AlertTitle>
                                        No se encontraron datos
                                      </Alert>
                                    )}
                                    <FilesViewItem
                                      label={i18n('entities.tarea.fields.documentosEnviados')}
                                      value={watchDocumentosEnviados}
                                    />
                                  </Box>
                                  <Box>
                                    <Typography variant="h4" pb={1}>
                                      Fotos Enviadas
                                    </Typography>
                                    {watchFotosEnviadas?.length === 0 && (
                                      <Alert severity="info">
                                        <AlertTitle>Sin Información</AlertTitle>
                                        No se encontraron datos
                                      </Alert>
                                    )}
                                    <ImagesViewItem
                                      label={i18n('entities.tarea.fields.fotosEnviadas')}
                                      value={watchFotosEnviadas}
                                    />
                                  </Box>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </React.Fragment>
                      </Grid>
                    </React.Fragment>
                  )}

                {!isTaskEditing && ['Cerrada', 'PendienteRevision', 'EnRevision'].includes(watchEstado) && (
                  <React.Fragment>
                    <Grid container direction="column">
                      {!props.hidePendienteView && (
                        <Grid item>
                          {/* <Box pl={1} pr={2}>
                            <PendienteView
                              drawer={props.drawer}
                              record={taskPreview}
                              dontOpenRecord={true}
                              hideComunicacionInterna={props.hideComunicacionInterna}
                              hideProgressbar={props.hideProgressbar}
                              hideExportButton={true}
                            />
                          </Box> */}
                          {watchModeloTarea?.descripcion && (
                            <Box p={1}>
                              <Box pl={0}>
                                <Typography variant={'h5'} color="textSecondary">
                                  {i18n('common.description')}
                                </Typography>
                              </Box>
                              <Box pl={0}>
                                <Typography variant={'body2'} color="textSecondary">
                                  {watchModeloTarea?.descripcion}
                                </Typography>
                              </Box>
                            </Box>
                          )}
                        </Grid>
                      )}

                      <React.Fragment>
                        {(progressEditor || recordHasProgress) && !isNewTaskWithoutId && (
                          <Box sx={{my: 1, px: 1, width: '100%'}}>
                            <TareaReportProgressPage
                              record={props.record}
                              updating
                              expandable
                              noBreadcrumb
                              readOnly={true}
                              onSaveSuccess={(id, values) => {
                                dispatch(actions.setRecord({...props.record, ...values}));
                              }}
                            />
                          </Box>
                        )}
                        {watchEstado === 'Rechazada' && (
                          <Grid sx={{p: 1}} item lg={12}>
                            <Alert severity="error">
                              <AlertTitle style={{marginBottom: 10}}>
                                {i18n('common.taskHasBeenRejected')}
                                {record.firmas?.length > 0 ? i18n('common.dueToFollowingReasons') : ''}
                              </AlertTitle>

                              {record.firmas
                                ?.filter((firma) => firma.nota)
                                ?.map((firma, index) => (
                                  <Grid key={index} style={{marginTop: 5}} container>
                                    {firma.nota}
                                  </Grid>
                                ))}
                            </Alert>
                          </Grid>
                        )}

                        {!!(watchFotosAdjuntas?.length || watchDocumentosAdjuntos?.length) && (
                          <Grid container sx={{p: 1}}>
                            <Grid item lg={props.drawer ? 12 : 3} md={8} sm={12} xs={12}>
                              <ImagesViewItem label={i18n('entities.tarea.fields.fotosAdjuntas')} value={watchFotosAdjuntas} />
                            </Grid>
                            <Grid item lg={props.drawer ? 12 : 3} md={8} sm={12} xs={12}>
                              <FilesViewItem
                                label={i18n('entities.tarea.fields.documentosAdjuntos')}
                                value={watchDocumentosAdjuntos}
                              />
                            </Grid>
                          </Grid>
                        )}

                        <Grid spacing={3} container sx={{p: 1}}>
                          {watchClasificacion === 'mantenimiento' && (
                            <Grid item lg={12}>
                              <ActivoListItem value={watchActivo} />
                            </Grid>
                          )}
                          {watchClasificacion === 'mantenimiento' && (
                            <React.Fragment>
                              {watchActivo?.tipoMedicionMantenimiento === 'Horas' && (
                                <Grid item lg={12} xs={12}>
                                  <Grid item sm={6} xs={12}>
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.addedHourmeter')}:{' '}
                                      {new Intl.NumberFormat('es-CL', {
                                        currency: 'CLP',
                                        style: 'decimal',
                                      }).format(watchHorometro || 0)}
                                    </label>
                                  </Grid>
                                  {/* fecha horometro */}
                                  <Grid item sm={6} xs={12}>
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.hourmeterDate')}:{' '}
                                      {watchFechaHorometro ? moment(watchFechaHorometro).format('DD-MM-YYYY') : ''}
                                    </label>
                                  </Grid>
                                </Grid>
                              )}

                              {watchActivo?.tipoMedicionMantenimiento === 'Kilometros' && (
                                <Grid item lg={12} xs={12}>
                                  <Grid item lg={props.drawer ? 12 : 5} md={8} sm={12} xs={12}>
                                    <label
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 20,
                                      }}>
                                      {i18n('common.addedMileage')}:{' '}
                                      {new Intl.NumberFormat('es-CL', {
                                        currency: 'CLP',
                                        style: 'decimal',
                                      }).format(watchKilometraje || 0)}
                                    </label>
                                  </Grid>
                                </Grid>
                              )}
                            </React.Fragment>
                          )}

                          {showMedicionesParcialId23 && (
                            <Grid item xs={12}>
                              <MedicionesParcialId23Section disabled={true} />
                            </Grid>
                          )}

                          {showMedicionesParcialId24 && (
                            <Grid item xs={12}>
                              <MedicionesParcialId24Section disabled={true} />
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Procedimiento' && (
                            <Grid item lg={props.drawer ? 12 : 6} xs={12}>
                              {watchEstructuraAnidada.length > 0 && (
                                <TareaProcedimientoAnidadoForm
                                  record={record}
                                  editar={false}
                                  esRespuesta={true}
                                  name="estructuraAnidada"
                                  customButton={props.principalFormButton}
                                  formValidationErrors={formValidationErrors}
                                />
                              )}
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Pasos' && (
                            <Grid item lg={props.drawer ? 12 : 6}>
                              <PasosTareaForm record={record} readOnly={true} name="respuestaInterfaz" />
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Checklist' && (
                            <Grid item lg={props.drawer ? 12 : 6}>
                              <CheckListTareaForm record={record} readOnly={true} name="respuestaInterfaz" />
                            </Grid>
                          )}

                          {watchTipoVisualizacion === 'Estandar' && (
                            <Grid item lg={props.drawer ? 12 : 6} mt={2}>
                              <Grid container direction="column" gap={2}>
                                <Box>
                                  <Typography variant="h4" pb={1}>
                                    {i18n('common.sentComment')}
                                  </Typography>
                                  <Typography variant="subtitle1" component="pre" whiteSpace="pre-line">
                                    {watchComentarioEnviado}
                                  </Typography>
                                  {!watchComentarioEnviado && (
                                    <Alert severity="info">
                                      <AlertTitle>{i18n('common.noInformation')}</AlertTitle>
                                      {i18n('common.noDataFound')}
                                    </Alert>
                                  )}
                                </Box>
                                <Box>
                                  <Typography variant="h4" pb={1}>
                                    {i18n('common.sentDocuments')}
                                  </Typography>
                                  {watchDocumentosEnviados?.length === 0 && (
                                    <Alert severity="info">
                                      <AlertTitle>{i18n('common.noInformation')}</AlertTitle>
                                      {i18n('common.noDataFound')}
                                    </Alert>
                                  )}
                                  <FilesViewItem
                                    label={i18n('entities.tarea.fields.documentosEnviados')}
                                    value={watchDocumentosEnviados}
                                  />
                                </Box>
                                <Box>
                                  <Typography variant="h4" pb={1}>
                                    {i18n('common.sentPhotos')}
                                  </Typography>
                                  {watchFotosEnviadas?.length === 0 && (
                                    <Alert severity="info">
                                      <AlertTitle>{i18n('common.noInformation')}</AlertTitle>
                                      {i18n('common.noDataFound')}
                                    </Alert>
                                  )}
                                  <ImagesViewItem
                                    label={i18n('entities.tarea.fields.fotosEnviadas')}
                                    value={watchFotosEnviadas}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          )}

                          <Grid style={{marginBottom: 30}} item lg={props.drawer ? 12 : 6}>
                            {record?.firmas
                              ?.filter((raw) => raw.responsable === currentUser.id)
                              ?.map((firma) => (
                                <Grid style={{marginTop: 5}} container>
                                  <Grid xs={12} lg={12}>
                                    <h2>
                                      {i18n('common.signs')} {currentUser.fullName}
                                    </h2>
                                    <hr />
                                  </Grid>
                                  <Grid style={{marginTop: 15}}>
                                    <FirmaListItem value={firma} />
                                  </Grid>
                                </Grid>
                              ))}
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    </Grid>
                  </React.Fragment>
                )}

                {/* tabla de detenciones */}
                {watchClasificacion === 'mantenimiento' &&
                  watchActivo?.tipoMedicionMantenimiento === 'Horas' &&
                  justificarHoras > 0 && (
                    <Grid item lg={props.drawer ? 12 : 6} style={{paddingBottom: 20}}>
                      <h2
                        style={{
                          marginBottom: 20,
                        }}>
                        {' '}
                        {i18n('common.detentions')}{' '}
                        {puedeResponder && (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            style={{
                              marginLeft: 20,
                            }}
                            onClick={() => {
                              appendDetencion({
                                horas: null,
                              });
                            }}
                            startIcon={<Add />}>
                            {i18n('common.add')}
                          </Button>
                        )}
                        <hr></hr>
                      </h2>
                      {!detenciones.length && !puedeResponder && (
                        <Alert severity="info">
                          <AlertTitle>{i18n('common.noInformation')}</AlertTitle>
                          {i18n('common.noDataFound')}
                        </Alert>
                      )}
                      {detenciones.length > 0 && (
                        <TableContainer component={Paper}>
                          <Table aria-label="simple table" id="detencionesTable">
                            <TableHead></TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell colSpan={4}>
                                  <label
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: 20,
                                    }}>
                                    {i18n('common.hoursPendingOfExplanation')}:{' '}
                                    <span
                                      style={{
                                        color: horasPorJustificar > 0 ? 'red' : 'green',
                                      }}>
                                      {horasPorJustificar}
                                    </span>
                                  </label>
                                  {/* {!horasPorJustificar && <CheckIcon style={{marginTop:-5, color:'green'}}/>} */}
                                </TableCell>
                              </TableRow>
                              {detenciones?.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    <DatePickerFormItem
                                      disabled={!puedeResponder}
                                      timeOnly
                                      name={`detenciones[${index}].hora`}
                                      label={i18n('common.detentionTime')}
                                      required={false}
                                      showTime={false}
                                      autoFocus
                                      defaultValue={row.hora || defaultFechaHorometro}
                                      onChange={(value) => {
                                        // combine fechaHorometro with hora
                                        const fechaHorometro = form.getValues('fechaHorometro');
                                        if (fechaHorometro) {
                                          //console.log('%c⧭ onChange hora', 'color: #d90000', {value});
                                          value = moment(value);
                                          const fechaHorometroWithHora = moment(fechaHorometro).set({
                                            hour: value?.get('hour'),
                                            minute: value?.get('minute'),
                                            second: value?.get('second'),
                                          });
                                          // console.log('%c⧭', 'color: #ffa640', {
                                          //   fechaHorometroWithHora: fechaHorometroWithHora.format('YYYY-MM-DD HH:mm:ss'),
                                          // });
                                          form.setValue(`detenciones[${index}].hora`, fechaHorometroWithHora);
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <DescRegistroAutocompleteFormItem
                                      disabled={!puedeResponder}
                                      name={`detenciones[${index}].descRegistro`}
                                      label={i18n('common.cause')}
                                      tipo="Detención"
                                      required={false}
                                      showCreate={false}
                                      minWidth={200}
                                      onChange={(value) => {
                                        form.setValue(`detenciones[${index}].descripcion`, value?.descripcion);
                                        if (value?.tipo) form.setValue(`detenciones[${index}].tipo`, value.tipo);
                                        if (value?.prioridad) form.setValue(`detenciones[${index}].prioridad`, value.prioridad);
                                        if (value?.afectaDisponibilidad)
                                          form.setValue(`detenciones[${index}].afectaDisponibilidad`, value.afectaDisponibilidad);
                                      }}
                                      menuPortalTarget={document.body}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <InputNumberFormItem
                                      disabled={!puedeResponder}
                                      name={`detenciones[${index}].horas`}
                                      label={i18n('common.detentionTime')}
                                      required={false}
                                      disableFormat={true}
                                      max={watchActivo?.cantidadHorasDisponibilidadDia || 11}
                                      min={0.25}
                                      step={0.25}
                                      defaultValue={null}
                                      style={{minWidth: '115px'}}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Tooltip followCursor title={form.watch(`detenciones[${index}].comentario`, '')}>
                                      <div>
                                        <InputFormItem
                                          disabled={!puedeResponder}
                                          name={`detenciones[${index}].comentario`}
                                          label={i18n('common.comment')}
                                          required={false}
                                          maxLength={200}
                                        />
                                      </div>
                                    </Tooltip>
                                  </TableCell>
                                  {puedeResponder && (
                                    <TableCell>
                                      <IconButton
                                        onClick={() => {
                                          removeDetencion(index);
                                        }}>
                                        <Delete />
                                      </IconButton>
                                    </TableCell>
                                  )}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Grid>
                  )}
                {firmasListas?.length > 0 && (
                  <Box style={{width: '100%'}} pl={2} pr={3} pb={4} mt={-6}>
                    <Box sx={{mx: 3, mb: 5}}>
                      <Typography variant="h3" sx={{textAlign: 'center', p: 1, borderBottom: '1px solid lightgray'}}>
                        {i18n('common.validationSignatures')}
                      </Typography>
                    </Box>

                    {/* Componente para agregar nueva firma */}
                    {canEditSignature && (
                      <Box sx={{mx: 3, mb: 5}}>
                        <UserAutocompleteFormItem
                          name="nuevoFirmante"
                          label={'Seleccionar nuevo firmante'}
                          onChange={(user) => {
                            if (!user) return;
                            if (!firmasListas.some((f) => f.responsable?.id === user.id)) {
                              setFirmasListas((prev) => [
                                ...prev,
                                {
                                  responsable: user.record,
                                  firma: user.record.firma,
                                  nuevo: true,
                                  fechaFirmada: new Date(),
                                },
                              ]);
                            }
                          }}
                        />
                      </Box>
                    )}

                    {/* Lista de firmas actuales */}
                    <Grid container direction="row" gap={4} justifyContent="center">
                      {firmasListas?.map((firma, index) => (
                        <Grid item textAlign="center" key={index}>
                          <Box sx={{borderBottom: '1px solid gray', width: 'min-content', mb: 1}}>
                            {(firma.firma || firma?.firmaRef?.publicUrl || firma?.firmaRef?.downloadUrl) && (
                              <img
                                alt={'signature'}
                                style={{
                                  width: 'auto',
                                  height: 100,
                                }}
                                src={firma.firma || firma?.firmaRef?.downloadUrl || firma?.firmaRef?.publicUrl}
                              />
                            )}
                          </Box>
                          <Typography variant="body2" align="center">
                            {firma.responsable?.fullName || 'Nombre no registrado'}
                          </Typography>
                          <Typography variant="caption" align="center">
                            {firma.responsable?.perfilEmpleado?.puesto?.nombre || ''}
                          </Typography>
                          <br></br>
                          {!canEditSignature && (
                            <Typography variant="caption" align="center">
                              {firma.fechaFirmada ? moment(firma.fechaFirmada).format('DD/MM/YYYY') : 'Sin fecha'}
                            </Typography>
                          )}
                          {canEditSignature && (
                            <DatePickerFormItem
                              name={`firmasListas[${index}].fechaFirmada`}
                              label={'Fecha de firma'}
                              required={false}
                              defaultValue={firma.fechaFirmada ? moment(firma.fechaFirmada) : null}
                              onChange={(value) => {
                                setFirmasListas((prev) =>
                                  prev.map((f, i) =>
                                    i === index ? {...f, editada: true, fechaFirmada: value ? value.toDate() : null} : f,
                                  ),
                                );
                              }}
                            />
                          )}

                          {/* Botón para eliminar firma */}
                          {canEditSignature && (
                            <Box mt={1}>
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => {
                                  // Elimina el firmante del array
                                  setFirmasListas((prev) => prev.filter((_, i) => i !== index));
                                }}>
                                Eliminar
                              </Button>
                            </Box>
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}

                {!['incidente', 'observacion', 'inspeccion'].includes(record.clasificacion) &&
                  !props.hideGuardarBorrador &&
                  roles?.includes('visualizadorRecursosAsignados') && (
                    <Grid
                      item
                      xs={12}
                      mt={2}
                      sx={{
                        minHeight: '400px',
                      }}>
                      <TareaResourcesForm disabled={!puedeResponder} />
                    </Grid>
                  )}
              </form>
            </FormProvider>
          </FormWrapper>
        </Box>
        <Dialog open={folioModalOpen} onClose={doCloseFolioModal} maxWidth="sm" fullWidth>
          <DialogTitle>Modificar folio</DialogTitle>
          <DialogContent>
            <Box pt={1}>
              <label style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12}}>
                <input type="checkbox" checked={removeNumeroCustom} onChange={(e) => setRemoveNumeroCustom(e.target.checked)} />
                Quitar folio actual
              </label>
            </Box>

            {!removeNumeroCustom && (
              <Box pt={1}>
                <TextField
                  fullWidth
                  select
                  size="small"
                  label="Folio alternativo"
                  value={selectedFolioPrefix || ''}
                  onChange={(event) => setSelectedFolioPrefix(event.target.value || null)}>
                  {folioOptionsForModal.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            )}

            <Box pt={2}>
              <label style={{display: 'flex', alignItems: 'center', gap: 8}}>
                <input
                  type="checkbox"
                  checked={applyFolioToChildren}
                  onChange={(e) => setApplyFolioToChildren(e.target.checked)}
                />
                Aplicar a tareas hijas
              </label>
            </Box>

            <Box pt={2}>
              <Typography variant="body2" color="textSecondary">
                Solo puedes seleccionar tipos de folio ya existentes. El sistema asignará el siguiente número disponible.
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={doCloseFolioModal} disabled={savingFolio}>
              Cancelar
            </Button>
            <Button
              onClick={doSaveFolio}
              variant="contained"
              disabled={savingFolio || (!removeNumeroCustom && !selectedFolioPrefix)}>
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
        {prePdfModalVisible && (
          <TareaPrePdfModal
            task={record}
            onChange={onChangePrePdfModal}
            onSuccess={onSuccessPrePdfModal}
            onCloseReady={onCloseReadyPrePdfModal}
            onCancel={onAbortPrePdfModal}
          />
        )}
      </ContentWrapper>
      {/* botones */}
      <Grid
        container
        spacing={3}
        style={{
          bottom: '5px',
        }}>
        {!isTaskEditing && ((puedeResponder && showStartButton) || !puedeResponder) && (
          <Grid item lg={6} xs={6}>
            {/* necesito el espacio que ocupa esto */}
          </Grid>
        )}
        {isTaskEditing && !showStartButton && (
          <Grid item lg={6} xs={6}>
            <Button
              style={{width: '100%', ...customButtonStyle}}
              variant="contained"
              color="secondary"
              disabled={saveLoading || waitingForAutosave}
              type="button"
              onClick={() => {
                onSave({...form.getValues(), updating: true});
              }}
              startIcon={<SaveOutlined />}
              size="large">
              {i18n('entities.tarea.editClosed.title')}
            </Button>
          </Grid>
        )}
        {!isTaskEditing && puedeResponder && !showStartButton && (
          <>
            <Grid item lg={6} xs={6}>
              <Button
                style={{width: '100%', ...customButtonStyle}}
                variant="contained"
                color="primary"
                disabled={saveLoading || waitingForAutosave}
                type="button"
                onClick={() => doConfirm()}
                startIcon={<SendOutlined />}
                size="large">
                {props.sendTareaText || i18n('common.sendTarea')}
              </Button>
            </Grid>
            {!props.hideGuardarBorrador && !isNewTaskWithoutId && (
              <Grid item lg={6} xs={6}>
                <Button
                  style={{width: '100%', ...customButtonStyle}}
                  variant="contained"
                  color="secondary"
                  disabled={saveLoading || waitingForAutosave}
                  type="button"
                  onClick={() => {
                    onSave({...form.getValues(), updating: true});
                  }}
                  startIcon={<SaveOutlined />}
                  size="large">
                  {i18n('common.draft')}
                </Button>
              </Grid>
            )}
          </>
        )}
      </Grid>
      {lastProcedureSavedAt && (
        <Box
          sx={{
            mt: 0.5,
            px: 0.5,
            textAlign: 'right',
          }}>
          <Typography
            component="span"
            sx={{
              fontSize: '0.75rem',
              fontStyle: 'italic',
              color: 'text.secondary',
              lineHeight: 1.2,
            }}>
            {i18n('common.lastSavedAt', lastProcedureSavedAt.format('HH:mm'))}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default TareaForm;
